function _0x571d() {
  const _0x22d9e3 = ["CONNECTION_RESTORING_SUCCESS", "1Zsfzen", "mEXzA", "TRANSACTION_SENT_FOR_SIGNATURE", "PtLdN", "purchase-failed", "unuKj", "WALLET_CONNECT_SUCCESS", "300uUfDaW", "TRANSACTION_SIGNED", "disconnection", "INVOICE_REGISTERED", "register-invoice", "Fidkw", "split", "connection-restoring-error", "46184qeDioo", "WzwLC", "SUBSCRIPTION_CANCELLED", "1276974SsFIoJ", "subscription-renewed", "PURCHASE_SUCCESS", "UMRjE", "upUoU", "purchase-cancelled", "816572PaqhXx", "QrQZI", "connection-restoring-started", "LHGhA", "45435aLbiHU", "18|5|7|14|0|4|13|15|17|10|3|8|11|21|6|1|20|23|19|2|16|12|9|22", "Vtihn", "WuZsw", "SUBSCRIPTION_STARTED", "595008ASvBJr", "CCBXU", "REFUND_ISSUED", "WALLET_CONNECT_STARTED", "HIDE", "https://tganalytics.xyz/", "711ArNTqw", "iOpPa", "FffNN", "UQzOt", "subscription-started", "2731580QnyFpC", "connection-completed", "1219022ZvIFXe", "embbl", "UZxdH", "PURCHASE_CANCELLED", "xWwKK", "SUBSCRIPTION_RENEWED", "app-hide", "aHJlm", "subscription-cancelled", "vjOso", "dhOoR", "custom-event", "CUSTOM_EVENT", "WALLET_DISCONNECT", "connection-restoring-completed", "TRANSACTION_SIGNING_FAILED", "connection-error", "transaction-signed", "qnspz", "TGA-Batch-Requests", "ihiCj", "INIT", "Nuucr", "PURCHASE_INIT", "transaction-signing-failed", "connection-started", "purchase-success", "purchase-init", "CONNECTION_RESTORING_STARTED", "SgLUs"];
  _0x571d = function() {
    return _0x22d9e3;
  };
  return _0x571d();
}
const _0x26863f = _0x48c2;
(function(_0x5eb336, _0x5ca748) {
  const _0x568726 = _0x48c2, _0x21068c = _0x5eb336();
  while (!![]) {
    try {
      const _0x1a0e1b = -parseInt(_0x568726(378)) / 1 * (-parseInt(_0x568726(402)) / 2) + -parseInt(_0x568726(396)) / 3 + parseInt(_0x568726(411)) / 4 + -parseInt(_0x568726(406)) / 5 * (parseInt(_0x568726(385)) / 6) + -parseInt(_0x568726(424)) / 7 + -parseInt(_0x568726(393)) / 8 * (-parseInt(_0x568726(417)) / 9) + parseInt(_0x568726(422)) / 10;
      if (_0x1a0e1b === _0x5ca748) break;
      else _0x21068c["push"](_0x21068c["shift"]());
    } catch (_0x4fc540) {
      _0x21068c["push"](_0x21068c["shift"]());
    }
  }
})(_0x571d, 232109);
function _0x48c2(_0xa8afe, _0x1f008) {
  const _0x571d8c = _0x571d();
  return _0x48c2 = function(_0x48c227, _0x4b7b66) {
    _0x48c227 = _0x48c227 - 364;
    let _0x55d4bd = _0x571d8c[_0x48c227];
    return _0x55d4bd;
  }, _0x48c2(_0xa8afe, _0x1f008);
}
const BACKEND_URL = _0x26863f(416);
const STAGING_BACKEND_URL = "https://staging.tganalytics.xyz/";
const BATCH_KEY = _0x26863f(366);
var Events = ((_0x223e6c) => {
  const _0x56f7a9 = _0x26863f, _0x33e68c = { "mEXzA": _0x56f7a9(407), "UQzOt": _0x56f7a9(423), "WuZsw": _0x56f7a9(398), "FffNN": _0x56f7a9(373), "LHGhA": _0x56f7a9(410), "PtLdN": _0x56f7a9(421), "SgLUs": _0x56f7a9(386), "Fidkw": "WALLET_CONNECT_ERROR", "dhOoR": _0x56f7a9(415), "Vtihn": _0x56f7a9(430), "embbl": _0x56f7a9(374), "QBTfd": _0x56f7a9(435), "xWwKK": _0x56f7a9(439), "CCBXU": _0x56f7a9(371), "unuKj": _0x56f7a9(388), "QXFJZ": _0x56f7a9(389), "WzwLC": _0x56f7a9(380), "Nuucr": "transaction-sent-for-signature", "NDZsC": _0x56f7a9(387), "OGMEc": _0x56f7a9(375), "UZxdH": _0x56f7a9(404), "MyOem": _0x56f7a9(414), "qnspz": _0x56f7a9(372), "vjOso": _0x56f7a9(438), "QrQZI": _0x56f7a9(429), "ihiCj": _0x56f7a9(397), "UdvXB": _0x56f7a9(368), "UMRjE": "PURCHASE_FAILED", "SNTgC": _0x56f7a9(382), "iOpPa": "ADDITIONAL_TASK_EVENT", "aHJlm": _0x56f7a9(427), "upUoU": _0x56f7a9(401) }, _0x452145 = _0x33e68c[_0x56f7a9(379)][_0x56f7a9(391)]("|");
  let _0x29d913 = 0;
  while (!![]) {
    switch (_0x452145[_0x29d913++]) {
      case "0":
        _0x223e6c[_0x56f7a9(384)] = _0x33e68c[_0x56f7a9(420)];
        continue;
      case "1":
        _0x223e6c[_0x33e68c[_0x56f7a9(409)]] = _0x33e68c[_0x56f7a9(419)];
        continue;
      case "2":
        _0x223e6c[_0x33e68c[_0x56f7a9(405)]] = _0x33e68c[_0x56f7a9(381)];
        continue;
      case "3":
        _0x223e6c[_0x33e68c[_0x56f7a9(376)]] = _0x56f7a9(364);
        continue;
      case "4":
        _0x223e6c[_0x33e68c[_0x56f7a9(390)]] = _0x56f7a9(440);
        continue;
      case "5":
        _0x223e6c[_0x33e68c[_0x56f7a9(434)]] = _0x33e68c[_0x56f7a9(408)];
        continue;
      case "6":
        _0x223e6c[_0x56f7a9(370)] = _0x33e68c[_0x56f7a9(425)];
        continue;
      case "7":
        _0x223e6c[_0x56f7a9(436)] = _0x33e68c["QBTfd"];
        continue;
      case "8":
        _0x223e6c[_0x33e68c[_0x56f7a9(428)]] = _0x33e68c[_0x56f7a9(412)];
        continue;
      case "9":
        _0x223e6c[_0x33e68c[_0x56f7a9(383)]] = _0x33e68c["QXFJZ"];
        continue;
      case "10":
        _0x223e6c[_0x33e68c[_0x56f7a9(394)]] = _0x33e68c[_0x56f7a9(369)];
        continue;
      case "11":
        _0x223e6c[_0x56f7a9(437)] = _0x33e68c["NDZsC"];
        continue;
      case "12":
        _0x223e6c[_0x56f7a9(395)] = _0x56f7a9(432);
        continue;
      case "13":
        _0x223e6c[_0x33e68c["OGMEc"]] = _0x33e68c[_0x56f7a9(426)];
        continue;
      case "14":
        _0x223e6c[_0x33e68c["MyOem"]] = _0x33e68c[_0x56f7a9(365)];
        continue;
      case "15":
        _0x223e6c[_0x56f7a9(377)] = _0x33e68c[_0x56f7a9(433)];
        continue;
      case "16":
        _0x223e6c[_0x33e68c[_0x56f7a9(403)]] = _0x33e68c[_0x56f7a9(367)];
        continue;
      case "17":
        _0x223e6c["CONNECTION_RESTORING_ERROR"] = _0x56f7a9(392);
        continue;
      case "18":
        _0x223e6c[_0x33e68c["UdvXB"]] = "app-init";
        continue;
      case "19":
        _0x223e6c[_0x56f7a9(413)] = "refund-issued";
        continue;
      case "20":
        _0x223e6c[_0x33e68c[_0x56f7a9(399)]] = _0x33e68c["SNTgC"];
        continue;
      case "21":
        _0x223e6c[_0x33e68c[_0x56f7a9(418)]] = _0x33e68c[_0x56f7a9(418)];
        continue;
      case "22":
        return _0x223e6c;
      case "23":
        _0x223e6c[_0x33e68c[_0x56f7a9(431)]] = _0x33e68c[_0x56f7a9(400)];
        continue;
    }
    break;
  }
})(Events || {});
function _0x295b() {
  const _0x2f4074 = ["tonConnectUiEvents", "addEventListener", "map", " listener", "TRANSACTION_SIGNING_FAILED", "sdkScope", "ton-connect-ui-", "WALLET_CONNECT_SUCCESS", "init", "events", "Attach ", "3|4|0|2|1", "CUSTOM_EVENT", "330GwEIlq", "analyticsController", "WALLET_CONNECT_ERROR", "uiScope", "977377MggDVw", "tonConnectSdkEvents", "event ", "TRANSACTION_SIGNED", "4240746cgDWNv", "21237120yTPFFG", "collectEvent", "ton-connect-", "1753696JTfSkA", "6WEmeEb", "52720ukVBlm", "split", "7402549yeLlHq", "detail", "2670140YMPYqS", "type", "uZyco"];
  _0x295b = function() {
    return _0x2f4074;
  };
  return _0x295b();
}
const _0x5b7869 = _0x3963;
(function(_0x59e4e6, _0x511be7) {
  const _0x3052c2 = _0x3963, _0x16a63a = _0x59e4e6();
  while (!![]) {
    try {
      const _0x20ffd7 = parseInt(_0x3052c2(342)) / 1 + parseInt(_0x3052c2(356)) / 2 + parseInt(_0x3052c2(346)) / 3 + -parseInt(_0x3052c2(352)) / 4 * (-parseInt(_0x3052c2(372)) / 5) + parseInt(_0x3052c2(351)) / 6 * (-parseInt(_0x3052c2(354)) / 7) + -parseInt(_0x3052c2(350)) / 8 + -parseInt(_0x3052c2(347)) / 9;
      if (_0x20ffd7 === _0x511be7) break;
      else _0x16a63a["push"](_0x16a63a["shift"]());
    } catch (_0x328c0e) {
      _0x16a63a["push"](_0x16a63a["shift"]());
    }
  }
})(_0x295b, 959510);
function _0x3963(_0xf3bc46, _0x10c3fa) {
  const _0x295b4d = _0x295b();
  return _0x3963 = function(_0x3963ab, _0x4df482) {
    _0x3963ab = _0x3963ab - 340;
    let _0x1b32a8 = _0x295b4d[_0x3963ab];
    return _0x1b32a8;
  }, _0x3963(_0xf3bc46, _0x10c3fa);
}
class TonConnectObserver {
  constructor(_0x536559) {
    const _0xb6fabf = _0x3963, _0x1c4b81 = { "RESYi": _0xb6fabf(370), "uZyco": _0xb6fabf(365) }, _0x31d7af = _0x1c4b81["RESYi"][_0xb6fabf(353)]("|");
    let _0x1a5261 = 0;
    while (!![]) {
      switch (_0x31d7af[_0x1a5261++]) {
        case "0":
          this[_0xb6fabf(341)] = _0x1c4b81[_0xb6fabf(358)];
          continue;
        case "1":
          this[_0xb6fabf(373)] = _0x536559;
          continue;
        case "2":
          this["sdkScope"] = _0xb6fabf(349);
          continue;
        case "3":
          this[_0xb6fabf(343)] = [Events[_0xb6fabf(371)], Events[_0xb6fabf(366)], Events["WALLET_CONNECT_ERROR"], Events["CONNECTION_RESTORING_SUCCESS"], Events["CONNECTION_RESTORING_ERROR"], Events["TRANSACTION_SENT_FOR_SIGNATURE"], Events[_0xb6fabf(345)], Events[_0xb6fabf(363)], Events["WALLET_DISCONNECT"]];
          continue;
        case "4":
          this["tonConnectUiEvents"] = [Events["WALLET_CONNECT_STARTED"], Events[_0xb6fabf(340)], Events["TRANSACTION_SIGNING_FAILED"]];
          continue;
      }
      break;
    }
  }
  [_0x5b7869(367)]() {
    const _0x32c269 = _0x5b7869;
    for (let _0x99d0cf of this[_0x32c269(368)]) {
      console["log"](_0x32c269(369) + _0x99d0cf + _0x32c269(362)), window[_0x32c269(360)](_0x99d0cf, (_0x41047f) => {
        const _0x57c464 = _0x32c269;
        console["log"](_0x57c464(344) + _0x99d0cf + " received", _0x41047f[_0x57c464(355)]);
        const { type: _0x2f58fc, ..._0x19e56b } = _0x41047f[_0x57c464(355)];
        this[_0x57c464(373)][_0x57c464(348)](_0x41047f[_0x57c464(355)][_0x57c464(357)], { ..._0x19e56b });
      });
    }
  }
  get [_0x5b7869(368)]() {
    const _0x29ed18 = _0x5b7869, _0x1a2c5e = this[_0x29ed18(359)][_0x29ed18(361)]((_0x1295e5) => "" + this[_0x29ed18(341)] + _0x1295e5), _0x2603e5 = this["tonConnectSdkEvents"][_0x29ed18(361)]((_0x290a90) => "" + this[_0x29ed18(364)] + _0x290a90);
    return [..._0x1a2c5e, ..._0x2603e5];
  }
}
(function(_0x17989f, _0x44ca74) {
  const _0x797f05 = _0x37b5, _0x3601f9 = _0x17989f();
  while (!![]) {
    try {
      const _0x47d54e = -parseInt(_0x797f05(484)) / 1 * (parseInt(_0x797f05(481)) / 2) + parseInt(_0x797f05(473)) / 3 + parseInt(_0x797f05(467)) / 4 * (-parseInt(_0x797f05(480)) / 5) + parseInt(_0x797f05(465)) / 6 * (-parseInt(_0x797f05(479)) / 7) + parseInt(_0x797f05(471)) / 8 + parseInt(_0x797f05(470)) / 9 + parseInt(_0x797f05(476)) / 10;
      if (_0x47d54e === _0x44ca74) break;
      else _0x3601f9["push"](_0x3601f9["shift"]());
    } catch (_0x300bbc) {
      _0x3601f9["push"](_0x3601f9["shift"]());
    }
  }
})(_0x391f, 906673);
function _0x37b5(_0x4adddb, _0x3dc24d) {
  const _0x391f50 = _0x391f();
  return _0x37b5 = function(_0x37b55a, _0x432b26) {
    _0x37b55a = _0x37b55a - 465;
    let _0x3b8a29 = _0x391f50[_0x37b55a];
    return _0x3b8a29;
  }, _0x37b5(_0x4adddb, _0x3dc24d);
}
class DocumentObserver {
  constructor(_0x58eeed) {
    const _0x393f69 = _0x37b5, _0x1a884f = { "lvrzj": function(_0x18d47e, _0x4fb76e) {
      return _0x18d47e === _0x4fb76e;
    }, "ChKev": _0x393f69(482), "KFLyL": "hidden" };
    this["documentEvents"] = { "visibilitychange": () => {
      const _0x42c225 = _0x393f69;
      if (_0x1a884f[_0x42c225(477)](_0x1a884f["ChKev"], _0x1a884f[_0x42c225(468)])) _0x1a884f[_0x42c225(477)](document[_0x42c225(478)], _0x1a884f[_0x42c225(475)]) && this[_0x42c225(472)][_0x42c225(469)](Events[_0x42c225(474)], void 0);
      else for (let [_0x20b608, _0x5703ae] of _0x34bf92[_0x42c225(466)](this[_0x42c225(483)])) {
        _0x1b53dc["addEventListener"](_0x20b608, _0x5703ae);
      }
    } }, this["analyticsController"] = _0x58eeed;
  }
  ["init"]() {
    const _0x2d5746 = _0x37b5;
    for (let [_0x5b9394, _0x543d43] of Object[_0x2d5746(466)](this["documentEvents"])) {
      document["addEventListener"](_0x5b9394, _0x543d43);
    }
  }
}
function _0x391f() {
  const _0xbd8493 = ["collectEvent", "470151eCcpaP", "11466312vWNKGH", "analyticsController", "1101138QAlasy", "HIDE", "KFLyL", "18881610HhTBLA", "lvrzj", "visibilityState", "1907689LPNWQt", "135LENMZI", "1210fGOzNh", "FbjSm", "documentEvents", "1359XEETKV", "6SLTJLb", "entries", "257680aBmSTl", "ChKev"];
  _0x391f = function() {
    return _0xbd8493;
  };
  return _0x391f();
}
const _0x54ff9a = _0x4f7c;
(function(_0x3a37e5, _0x10a113) {
  const _0x2231ac = _0x4f7c, _0x22edc2 = _0x3a37e5();
  while (!![]) {
    try {
      const _0x713da5 = parseInt(_0x2231ac(339)) / 1 + parseInt(_0x2231ac(348)) / 2 + parseInt(_0x2231ac(341)) / 3 * (-parseInt(_0x2231ac(333)) / 4) + parseInt(_0x2231ac(337)) / 5 + parseInt(_0x2231ac(335)) / 6 + -parseInt(_0x2231ac(340)) / 7 + -parseInt(_0x2231ac(346)) / 8;
      if (_0x713da5 === _0x10a113) break;
      else _0x22edc2["push"](_0x22edc2["shift"]());
    } catch (_0x47df51) {
      _0x22edc2["push"](_0x22edc2["shift"]());
    }
  }
})(_0x368c, 859846);
class TappsObserver {
  constructor(_0x37c256) {
    const _0x3d378e = _0x4f7c;
    this[_0x3d378e(336)] = [Events[_0x3d378e(338)]], this[_0x3d378e(349)] = _0x37c256;
  }
  [_0x54ff9a(342)]() {
    const _0x5c76f7 = _0x54ff9a;
    for (let _0x2dd59e of this[_0x5c76f7(336)]) {
      console[_0x5c76f7(347)](_0x5c76f7(344) + _0x2dd59e + _0x5c76f7(334)), window["addEventListener"](_0x2dd59e, (_0x262c30) => {
        const _0x198fca = _0x5c76f7;
        console["log"](_0x198fca(343) + _0x2dd59e + _0x198fca(331), _0x262c30["detail"]);
        const { type: _0x4104aa, ..._0x360580 } = _0x262c30[_0x198fca(345)];
        this["analyticsController"]["collectTappsEvent"](_0x262c30[_0x198fca(345)][_0x198fca(332)], { ..._0x360580 });
      });
    }
  }
}
function _0x4f7c(_0x5671a3, _0x4dac43) {
  const _0x368cf7 = _0x368c();
  return _0x4f7c = function(_0x4f7c2e, _0x386843) {
    _0x4f7c2e = _0x4f7c2e - 331;
    let _0x170c8b = _0x368cf7[_0x4f7c2e];
    return _0x170c8b;
  }, _0x4f7c(_0x5671a3, _0x4dac43);
}
function _0x368c() {
  const _0x455321 = ["8mFYUOb", " listener", "710406BuWZMS", "telegramAppsCenterEvents", "6185180iGXqqJ", "ADDITIONAL_TASK_EVENT", "1692457yidStR", "4825639UVrjMw", "1630971rqDgZn", "init", "event ", "Attach ", "detail", "4100640pfAGOv", "log", "202446hMmjoO", "analyticsController", " received", "type"];
  _0x368c = function() {
    return _0x455321;
  };
  return _0x368c();
}
(function(_0x1cf1f9, _0x48ef97) {
  const _0x5c2af5 = _0x4630, _0x1a3ec8 = _0x1cf1f9();
  while (!![]) {
    try {
      const _0x118019 = -parseInt(_0x5c2af5(320)) / 1 + parseInt(_0x5c2af5(300)) / 2 + parseInt(_0x5c2af5(315)) / 3 * (parseInt(_0x5c2af5(316)) / 4) + -parseInt(_0x5c2af5(317)) / 5 * (parseInt(_0x5c2af5(309)) / 6) + -parseInt(_0x5c2af5(302)) / 7 + parseInt(_0x5c2af5(307)) / 8 + parseInt(_0x5c2af5(311)) / 9 * (parseInt(_0x5c2af5(301)) / 10);
      if (_0x118019 === _0x48ef97) break;
      else _0x1a3ec8["push"](_0x1a3ec8["shift"]());
    } catch (_0x1aa81c) {
      _0x1a3ec8["push"](_0x1a3ec8["shift"]());
    }
  }
})(_0x5321, 108328);
function _0x5321() {
  const _0x46857d = ["Telegram", "slice", "138563NokzqH", "undefined", "split", "KYIxP", "openInvoice", "413902WlhVPj", "591190DONYBP", "1134903FtgrZR", "collectEvent", "WebApp", "startsWith", "jBVFA", "191440bGSqCc", "NNBlx", "6lulqva", "SgPZu", "18aDLeae", "VAecz", "pop", "webApp", "6ruAZqH", "130196LjLXqV", "25985ICNYHi"];
  _0x5321 = function() {
    return _0x46857d;
  };
  return _0x5321();
}
function _0x4630(_0x462416, _0x3f4df8) {
  const _0x5321cf = _0x5321();
  return _0x4630 = function(_0x4630ec, _0x44b4bd) {
    _0x4630ec = _0x4630ec - 299;
    let _0xbf8004 = _0x5321cf[_0x4630ec];
    return _0xbf8004;
  }, _0x4630(_0x462416, _0x3f4df8);
}
class WebAppObserver {
  constructor(_0x132032) {
    var _a;
    const _0x53206d = _0x4630, _0x79b953 = { "SgPZu": function(_0x2c523b, _0x1fd01d) {
      return _0x2c523b !== _0x1fd01d;
    }, "KYIxP": _0x53206d(321) };
    this[_0x53206d(314)] = _0x79b953[_0x53206d(310)](typeof window, _0x79b953[_0x53206d(323)]) && ((_a = window == null ? void 0 : window["Telegram"]) == null ? void 0 : _a[_0x53206d(304)]) ? window[_0x53206d(318)]["WebApp"] : null, this["analyticsController"] = _0x132032;
  }
  ["init"]() {
    var _a;
    const _0x31a243 = _0x4630, _0x1bb0eb = { "jBVFA": function(_0x1d55e7, _0x2e694f) {
      return _0x1d55e7 !== _0x2e694f;
    }, "NNBlx": _0x31a243(312) };
    if (this["webApp"] && ((_a = this[_0x31a243(314)]) == null ? void 0 : _a["openInvoice"])) {
      const _0x4a2b26 = this["webApp"][_0x31a243(299)];
      this[_0x31a243(314)][_0x31a243(299)] = (_0x2ff28c, _0xf51e39) => {
        const _0x528d67 = _0x31a243;
        if (_0x1bb0eb[_0x528d67(306)](_0x1bb0eb[_0x528d67(308)], _0x1bb0eb[_0x528d67(308)])) _0x3d7de2 = _0x341716[_0x528d67(319)](1);
        else {
          let _0x2a46a0 = _0x2ff28c[_0x528d67(322)]("/")[_0x528d67(313)]() || "";
          return _0x2a46a0[_0x528d67(305)]("$") && (_0x2a46a0 = _0x2a46a0[_0x528d67(319)](1)), this["analyticsController"][_0x528d67(303)](Events["PURCHASE_INIT"], { "slug": _0x2a46a0 }), _0x4a2b26["call"](this["webApp"], _0x2ff28c, _0xf51e39);
        }
      };
    }
  }
}
const _0x1c0712 = _0x3140;
function _0x3140(_0x4c3152, _0xd7e359) {
  const _0x37842d = _0x3784();
  return _0x3140 = function(_0x31406f, _0x307fa4) {
    _0x31406f = _0x31406f - 398;
    let _0x37c178 = _0x37842d[_0x31406f];
    return _0x37c178;
  }, _0x3140(_0x4c3152, _0xd7e359);
}
(function(_0xdf7266, _0x3185f3) {
  const _0x1ed922 = _0x3140, _0x25e705 = _0xdf7266();
  while (!![]) {
    try {
      const _0xc1a5ce = -parseInt(_0x1ed922(427)) / 1 + parseInt(_0x1ed922(428)) / 2 * (-parseInt(_0x1ed922(424)) / 3) + -parseInt(_0x1ed922(430)) / 4 + -parseInt(_0x1ed922(436)) / 5 * (parseInt(_0x1ed922(421)) / 6) + parseInt(_0x1ed922(420)) / 7 + parseInt(_0x1ed922(398)) / 8 + parseInt(_0x1ed922(403)) / 9 * (parseInt(_0x1ed922(417)) / 10);
      if (_0xc1a5ce === _0x3185f3) break;
      else _0x25e705["push"](_0x25e705["shift"]());
    } catch (_0x388ccb) {
      _0x25e705["push"](_0x25e705["shift"]());
    }
  }
})(_0x3784, 919783);
function _0x3784() {
  const _0x5e5199 = ["WebView", "analyticsController", "status", "svsaI", "5RIZTEw", "BTqxu", "1152712vPSMwy", "TelegramGameProxy_receiveEvent", "collectEvent", "Telegram", "dLhgR", "33183fiarei", "addEventListener", "PURCHASE_SUCCESS", "message", "fzpva", "call", "handleEvents", "handlePlatformListener", "invoice_closed", "sUIxY", "PURCHASE_CANCELLED", "receiveEvent", "eventStatusMap", "hniSW", "15070qyLJxe", "ptWwN", "dBiGz", "3313863dDwppu", "10507956iSaPiw", "parse", "SswJM", "4497099FgFVOU", "PURCHASE_FAILED", "nnfbm", "1219756Nxcput", "2JFxmUl", "TdAdM", "3135636DsMWPt", "TelegramGameProxy"];
  _0x3784 = function() {
    return _0x5e5199;
  };
  return _0x3784();
}
class WebViewObserver {
  constructor(_0x450b73) {
    const _0x401fc6 = _0x3140;
    this[_0x401fc6(415)] = { "paid": Events[_0x401fc6(405)], "cancelled": Events[_0x401fc6(413)], "failed": Events[_0x401fc6(425)] }, this[_0x401fc6(433)] = _0x450b73;
  }
  ["init"]() {
    const _0x3e66fb = _0x3140, _0x28f870 = { "ptWwN": _0x3e66fb(406) };
    window["addEventListener"](_0x28f870[_0x3e66fb(418)], ({ data: _0x353a99 }) => {
      const _0x195f01 = _0x3e66fb;
      try {
        const { eventType: _0x30cb8a, eventData: _0x1e078e } = JSON[_0x195f01(422)](_0x353a99);
        this[_0x195f01(409)](_0x30cb8a, _0x1e078e);
      } catch (_0x3231bc) {
      }
    }), this["handlePlatformListener"](window[_0x3e66fb(431)]), this["handlePlatformListener"](window[_0x3e66fb(401)][_0x3e66fb(432)]), this[_0x3e66fb(410)](window["TelegramGameProxy_receiveEvent"]);
  }
  [_0x1c0712(410)](_0x54c4bb) {
    const _0x23d95a = _0x1c0712, _0x295ade = { "svsaI": function(_0xf34b40, _0x428901) {
      return _0xf34b40 !== _0x428901;
    }, "BTqxu": _0x23d95a(419), "nnfbm": _0x23d95a(429) };
    if (!_0x54c4bb) return;
    let _0x129bce;
    if (_0x54c4bb == null ? void 0 : _0x54c4bb[_0x23d95a(414)]) _0x295ade[_0x23d95a(435)](_0x23d95a(419), _0x295ade[_0x23d95a(437)]) ? _0x517e64 = _0x56c4d3[_0x23d95a(414)] : _0x129bce = _0x54c4bb[_0x23d95a(414)];
    else {
      if (_0x295ade[_0x23d95a(426)] === "gAytR") return;
      else _0x129bce = _0x54c4bb, _0x54c4bb = window;
    }
    const _0x3e96f4 = this;
    _0x54c4bb[_0x23d95a(414)] = (_0x4b0f2c, _0x22ffa2) => {
      const _0x5314df = _0x23d95a;
      return _0x3e96f4["handleEvents"](_0x4b0f2c, _0x22ffa2), _0x129bce[_0x5314df(408)](_0x54c4bb, _0x4b0f2c, _0x22ffa2);
    };
  }
  [_0x1c0712(409)](_0x1d6ffb, _0x4c3327) {
    const _0x15097d = _0x1c0712, _0x1cd824 = { "TtKjZ": _0x15097d(406), "fzpva": _0x15097d(411), "fILcb": function(_0x1f3867, _0x4248ca) {
      return _0x1f3867 !== _0x4248ca;
    }, "hniSW": _0x15097d(423), "dLhgR": _0x15097d(412) };
    if (_0x1d6ffb === _0x1cd824[_0x15097d(407)]) {
      if (_0x1cd824["fILcb"](_0x15097d(423), _0x1cd824[_0x15097d(416)])) return _0x310eab["handleEvents"](_0x2bcb32, _0x52b909), _0x257da7[_0x15097d(408)](_0x2a8500, _0x3d9b91, _0x27a0f7);
      else this[_0x15097d(415)][_0x4c3327[_0x15097d(434)]] && (_0x1cd824[_0x15097d(402)] === _0x1cd824[_0x15097d(402)] ? this[_0x15097d(433)][_0x15097d(400)](this["eventStatusMap"][_0x4c3327["status"]], { "slug": _0x4c3327["slug"] }) : (_0x39d983[_0x15097d(404)](_0x1cd824["TtKjZ"], ({ data: _0x3a6367 }) => {
        const _0x5a7911 = _0x15097d;
        try {
          const { eventType: _0x1579a6, eventData: _0x5a3d37 } = _0x21ab63[_0x5a7911(422)](_0x3a6367);
          this["handleEvents"](_0x1579a6, _0x5a3d37);
        } catch (_0x18dd7f) {
        }
      }), this[_0x15097d(410)](_0x36e790["TelegramGameProxy"]), this[_0x15097d(410)](_0x1817fc[_0x15097d(401)][_0x15097d(432)]), this[_0x15097d(410)](_0x22b43c[_0x15097d(399)])));
    }
  }
}
function _0x1e83(_0x141fd2, _0x5b0a31) {
  var _0x4f2820 = _0x4f28();
  return _0x1e83 = function(_0x1e83f1, _0x5308f7) {
    _0x1e83f1 = _0x1e83f1 - 368;
    var _0x1c6dba = _0x4f2820[_0x1e83f1];
    return _0x1c6dba;
  }, _0x1e83(_0x141fd2, _0x5b0a31);
}
var _0x3a7464 = _0x1e83;
(function(_0x119fe9, _0x4887d0) {
  var _0x253b42 = _0x1e83, _0x5331e4 = _0x119fe9();
  while (!![]) {
    try {
      var _0x56eb1c = parseInt(_0x253b42(388)) / 1 + parseInt(_0x253b42(394)) / 2 * (parseInt(_0x253b42(381)) / 3) + -parseInt(_0x253b42(387)) / 4 * (-parseInt(_0x253b42(395)) / 5) + parseInt(_0x253b42(377)) / 6 * (-parseInt(_0x253b42(399)) / 7) + parseInt(_0x253b42(386)) / 8 * (parseInt(_0x253b42(379)) / 9) + parseInt(_0x253b42(374)) / 10 + -parseInt(_0x253b42(375)) / 11 * (parseInt(_0x253b42(376)) / 12);
      if (_0x56eb1c === _0x4887d0) break;
      else _0x5331e4["push"](_0x5331e4["shift"]());
    } catch (_0x16cea6) {
      _0x5331e4["push"](_0x5331e4["shift"]());
    }
  }
})(_0x4f28, 910625);
function _0x4f28() {
  var _0x2f798e = ["1|5|3|2|0|4", "88PMUbsY", "57404rRnokS", "994889sxOFVL", "mPEiv", "split", "EzvSu", "events/threshold", "tappsObserver", "9502NmgObP", "435FSRxLD", "env", "bUPdk", "collectEvent", "1230761qjOOAK", "timeout", "collectTappsEvent", "2|4|0|3|5|1", "catch", "documentObserver", "eventsThreshold", "tonConnectObserver", "webAppObserver", "json", "error", "14299230EumrIv", "275xowRro", "1985388qZydzf", "42oGIUWN", "appModule", "1193949HDrMUz", "recordEvent", "723vmaEGN", "tITvZ", "init", "STG"];
  _0x4f28 = function() {
    return _0x2f798e;
  };
  return _0x4f28();
}
class AnalyticsController {
  constructor(_0x3c1a05) {
    var _0x27dda8 = _0x1e83, _0x42e43f = { "RebVA": _0x27dda8(385) }, _0x3a707c = _0x42e43f["RebVA"][_0x27dda8(390)]("|"), _0x105156 = 0;
    while (!![]) {
      switch (_0x3a707c[_0x105156++]) {
        case "0":
          this["webViewObserver"] = new WebViewObserver(this);
          continue;
        case "1":
          this[_0x27dda8(378)] = _0x3c1a05;
          continue;
        case "2":
          this[_0x27dda8(371)] = new WebAppObserver(this);
          continue;
        case "3":
          this[_0x27dda8(370)] = new TonConnectObserver(this);
          continue;
        case "4":
          this[_0x27dda8(393)] = new TappsObserver(this);
          continue;
        case "5":
          this[_0x27dda8(368)] = new DocumentObserver(this);
          continue;
      }
      break;
    }
  }
  async [_0x3a7464(383)]() {
    var _0x2922d3 = _0x3a7464, _0x117dfe = { "EzvSu": _0x2922d3(402), "bUPdk": function(_0x295f79, _0x5cd03b) {
      return _0x295f79 + _0x5cd03b;
    }, "tITvZ": function(_0xcf68ff, _0x20d4a8) {
      return _0xcf68ff === _0x20d4a8;
    } }, _0x2526da = _0x117dfe[_0x2922d3(391)]["split"]("|"), _0xf04a11 = 0;
    while (!![]) {
      switch (_0x2526da[_0xf04a11++]) {
        case "0":
          this[_0x2922d3(371)][_0x2922d3(383)]();
          continue;
        case "1":
          try {
            this[_0x2922d3(369)] = await (await fetch(_0x117dfe[_0x2922d3(397)](_0x117dfe[_0x2922d3(382)](this[_0x2922d3(378)][_0x2922d3(396)], _0x2922d3(384)) ? STAGING_BACKEND_URL : BACKEND_URL, _0x2922d3(392)), { "signal": AbortSignal[_0x2922d3(400)](2e3) }))[_0x2922d3(372)]();
          } catch (_0x4c5689) {
            this["eventsThreshold"] = { "app-hide": 3 };
          }
          continue;
        case "2":
          this[_0x2922d3(368)]["init"]();
          continue;
        case "3":
          this["webViewObserver"]["init"]();
          continue;
        case "4":
          this["tonConnectObserver"][_0x2922d3(383)]();
          continue;
        case "5":
          this[_0x2922d3(393)][_0x2922d3(383)]();
          continue;
      }
      break;
    }
  }
  ["recordEvent"](_0x565338, _0x3801bd) {
    var _0x497407 = _0x3a7464;
    this[_0x497407(378)][_0x497407(380)](_0x565338, _0x3801bd)[_0x497407(403)]((_0x12ab6a) => console[_0x497407(373)](_0x12ab6a));
  }
  [_0x3a7464(398)](_0x24eddb, _0x18b170) {
    var _0x21f639 = _0x3a7464, _0x43d804 = { "mPEiv": function(_0x4ee366, _0xdc0276) {
      return _0x4ee366 === _0xdc0276;
    } };
    if (_0x43d804[_0x21f639(389)](this[_0x21f639(369)][_0x24eddb], 0)) return;
    this[_0x21f639(378)][_0x21f639(398)](_0x24eddb, _0x18b170), this[_0x21f639(369)][_0x24eddb] && this["eventsThreshold"][_0x24eddb]--;
  }
  [_0x3a7464(401)](_0x12dd11, _0x387e56) {
    var _0x405d56 = _0x3a7464;
    this[_0x405d56(378)][_0x405d56(401)](_0x12dd11, _0x387e56);
  }
}
(function(_0x5d44e9, _0x2780fc) {
  const _0x16a672 = _0x146a, _0x3da9d1 = _0x5d44e9();
  while (!![]) {
    try {
      const _0x7f92d = parseInt(_0x16a672(330)) / 1 + parseInt(_0x16a672(315)) / 2 * (parseInt(_0x16a672(328)) / 3) + -parseInt(_0x16a672(317)) / 4 + parseInt(_0x16a672(322)) / 5 * (-parseInt(_0x16a672(325)) / 6) + parseInt(_0x16a672(323)) / 7 * (parseInt(_0x16a672(329)) / 8) + parseInt(_0x16a672(318)) / 9 + -parseInt(_0x16a672(324)) / 10;
      if (_0x7f92d === _0x2780fc) break;
      else _0x3da9d1["push"](_0x3da9d1["shift"]());
    } catch (_0x22e2fd) {
      _0x3da9d1["push"](_0x3da9d1["shift"]());
    }
  }
})(_0x17bd, 633189);
function _0x146a(_0x6f0aeb, _0x2312df) {
  const _0x17bd97 = _0x17bd();
  return _0x146a = function(_0x146ad0, _0x200ddc) {
    _0x146ad0 = _0x146ad0 - 315;
    let _0x5efbf1 = _0x17bd97[_0x146ad0];
    return _0x5efbf1;
  }, _0x146a(_0x6f0aeb, _0x2312df);
}
const throwError = (_0x340ac6) => {
  throw new Error(_0x340ac6);
};
var Errors = ((_0x56bf0d) => {
  const _0x4f5889 = _0x146a, _0x18e1d7 = { "TiQsB": _0x4f5889(316), "MDqeq": _0x4f5889(321), "bVsrO": _0x4f5889(327), "rWqSB": "Telegram User data is not provided." };
  return _0x56bf0d[_0x18e1d7["TiQsB"]] = _0x18e1d7[_0x4f5889(320)], _0x56bf0d[_0x18e1d7[_0x4f5889(326)]] = _0x18e1d7[_0x4f5889(319)], _0x56bf0d;
})(Errors || {});
function _0x17bd() {
  const _0x4b387f = ["1079844HnJhpW", "1478259oBcDma", "rWqSB", "MDqeq", "Token is not provided.", "3772225moxoNM", "7DRenId", "7632800UqaTEk", "6oLzzPj", "bVsrO", "USER_DATA_IS_NOT_PROVIDED", "141mrMaZI", "9830360ksvIdt", "332370fvGIaG", "29594bLwZyx", "TOKEN_IS_NOT_PROVIDED"];
  _0x17bd = function() {
    return _0x4b387f;
  };
  return _0x17bd();
}
function _0x5454(_0x1058cc, _0x18e3fe) {
  const _0x4df6f0 = _0x4df6();
  return _0x5454 = function(_0x54547f, _0x4fd087) {
    _0x54547f = _0x54547f - 160;
    let _0x24e682 = _0x4df6f0[_0x54547f];
    return _0x24e682;
  }, _0x5454(_0x1058cc, _0x18e3fe);
}
(function(_0x128ce1, _0xa649cc) {
  const _0x12a2c8 = _0x5454, _0x1ae240 = _0x128ce1();
  while (!![]) {
    try {
      const _0x1e5c1c = -parseInt(_0x12a2c8(170)) / 1 + -parseInt(_0x12a2c8(163)) / 2 * (-parseInt(_0x12a2c8(174)) / 3) + parseInt(_0x12a2c8(169)) / 4 * (-parseInt(_0x12a2c8(161)) / 5) + parseInt(_0x12a2c8(166)) / 6 * (-parseInt(_0x12a2c8(162)) / 7) + parseInt(_0x12a2c8(160)) / 8 + -parseInt(_0x12a2c8(164)) / 9 * (-parseInt(_0x12a2c8(173)) / 10) + -parseInt(_0x12a2c8(165)) / 11 * (-parseInt(_0x12a2c8(168)) / 12);
      if (_0x1e5c1c === _0xa649cc) break;
      else _0x1ae240["push"](_0x1ae240["shift"]());
    } catch (_0x368af9) {
      _0x1ae240["push"](_0x1ae240["shift"]());
    }
  }
})(_0x4df6, 590688);
function _0x4df6() {
  const _0x3f7f4e = ["18OdwhhL", "pipeThrough", "1056AxNeSm", "620UUJPAc", "622744tlzxvh", "gzip", "stringify", "16650RCUbrJ", "27057plGcTe", "stream", "JvdJO", "7204424NYiIgd", "6845xmaOCb", "2356732hOvKrA", "192FAHBrE", "630nZrLDt", "69091JaDGyR"];
  _0x4df6 = function() {
    return _0x3f7f4e;
  };
  return _0x4df6();
}
async function compressData(_0x91d253) {
  const _0x2c4448 = _0x5454, _0x6a03d2 = { "JvdJO": _0x2c4448(171) }, _0x53be3f = new Blob([JSON[_0x2c4448(172)](_0x91d253)])[_0x2c4448(175)](), _0x2058ad = _0x53be3f[_0x2c4448(167)](new CompressionStream(_0x6a03d2[_0x2c4448(176)]));
  return await new Response(_0x2058ad)["blob"]();
}
function _0x1e33() {
  const _0x15be4c = ["bkePV", "1419760jOGRqN", "dHUdK", "Content-Encoding", "8397ciKlQv", "status", "iIacb", "Content", "env", "4niHiqd", "pdKfP", "AdQXy", "solveTask", "9736048VImOsH", "AHVwF", "210783jFVmiD", "qefdG", "4FknFFI", "525838EeXskP", "qHNVK", "nkefv", "TOKEN_IS_NOT_PROVIDED", "10110hifSEH", "DliRF", "lKVYA", "7169094YEYcld", "usPdD", "GafhV", "events", "krCXi", "TmUqJ", "appModule", "qQqpI", "oMpiO", "application/json", "assembleEventSession", "fTSku", "init", "znhjc", "gzip", "taskSolution", "fBvop", "dzTin", "BACKEND_URL", "recordEvents", "generateHeaders", "json", "clone", "TeoTU", "NExcc", "NPeRE", "31277972RdTPMr", "stringify", "getApiToken", "responseToParams", "yRQjc", "7QKpnLe", "KTRBd", "then", "setNewArgs", "recordEvent", "custom_data", "kclus", "DdNph", "FhQhk", "DNARh"];
  _0x1e33 = function() {
    return _0x15be4c;
  };
  return _0x1e33();
}
const _0x36945 = _0xd2b2;
(function(_0x356cd5, _0x566c45) {
  const _0x4260d1 = _0xd2b2, _0x29b8ec = _0x356cd5();
  while (!![]) {
    try {
      const _0x518630 = parseInt(_0x4260d1(208)) / 1 * (parseInt(_0x4260d1(209)) / 2) + -parseInt(_0x4260d1(206)) / 3 * (parseInt(_0x4260d1(200)) / 4) + parseInt(_0x4260d1(192)) / 5 + parseInt(_0x4260d1(150)) / 6 * (-parseInt(_0x4260d1(181)) / 7) + -parseInt(_0x4260d1(204)) / 8 + -parseInt(_0x4260d1(195)) / 9 * (parseInt(_0x4260d1(147)) / 10) + parseInt(_0x4260d1(176)) / 11;
      if (_0x518630 === _0x566c45) break;
      else _0x29b8ec["push"](_0x29b8ec["shift"]());
    } catch (_0x1616f6) {
      _0x29b8ec["push"](_0x29b8ec["shift"]());
    }
  }
})(_0x1e33, 753701);
function _0xd2b2(_0x16a5a1, _0x125e66) {
  const _0x1e33f4 = _0x1e33();
  return _0xd2b2 = function(_0xd2b286, _0x1d3c2c) {
    _0xd2b286 = _0xd2b286 - 146;
    let _0x47973a = _0x1e33f4[_0xd2b286];
    return _0x47973a;
  }, _0xd2b2(_0x16a5a1, _0x125e66);
}
class NetworkController {
  constructor(_0x528f24) {
    const _0x243438 = _0xd2b2, _0x1bc047 = { "qQqpI": function(_0x1852f8, _0x5f3de6) {
      return _0x1852f8 === _0x5f3de6;
    }, "usPdD": function(_0x4acd0b, _0x1d7ea4) {
      return _0x4acd0b(_0x1d7ea4);
    }, "pdKfP": function(_0x1e2619, _0x477cbd) {
      return _0x1e2619 === _0x477cbd;
    }, "dHUdK": _0x243438(198), "dTIKc": _0x243438(194), "DNARh": _0x243438(164), "AHVwF": function(_0x4613e9, _0xdc591b) {
      return _0x4613e9 !== _0xdc591b;
    }, "kclus": _0x243438(163), "gSHRS": _0x243438(202), "KTRBd": _0x243438(159), "GafhV": function(_0x306df8, _0x5d13fa) {
      return _0x306df8 === _0x5d13fa;
    }, "fBvop": "STG" };
    this[_0x243438(168)] = BACKEND_URL, this[_0x243438(179)] = async (_0x5c12a6) => {
      const _0x4c9dd5 = _0x243438, _0x2cc8bb = _0x5c12a6[_0x4c9dd5(172)]();
      if (_0x1bc047[_0x4c9dd5(157)](_0x1bc047[_0x4c9dd5(151)](String, _0x2cc8bb[_0x4c9dd5(196)])[0], "2") || _0x1bc047[_0x4c9dd5(201)](_0x2cc8bb[_0x4c9dd5(196)], 429)) {
        const _0xc17181 = await _0x2cc8bb[_0x4c9dd5(171)]();
        this[_0x4c9dd5(156)][_0x4c9dd5(184)](_0xc17181[_0x1bc047[_0x4c9dd5(193)]]);
      }
      return _0x5c12a6;
    }, this["generateHeaders"] = (_0x35b8c7) => {
      const _0x45ab0b = _0x243438, _0x358d46 = { "yRQjc": _0x45ab0b(198), "FhQhk": _0x1bc047["dTIKc"], "lKVYA": _0x1bc047[_0x45ab0b(190)] };
      if (_0x1bc047["AHVwF"](_0x1bc047[_0x45ab0b(187)], _0x1bc047[_0x45ab0b(187)])) {
        this["appModule"][_0x45ab0b(203)]();
        const _0x21a26b = {};
        return this[_0x45ab0b(156)]["taskSolution"] && (_0x21a26b[_0x358d46[_0x45ab0b(180)]] = this[_0x45ab0b(156)][_0x45ab0b(165)]), _0xd2fb59 && (_0x21a26b[_0x358d46[_0x45ab0b(189)]] = _0x358d46[_0x45ab0b(149)]), { "TGA-Auth-Token": this["appModule"]["getApiToken"](), "Content-Type": _0x45ab0b(159), ..._0x21a26b };
      } else {
        this[_0x45ab0b(156)][_0x45ab0b(203)]();
        const _0x16b089 = {};
        return this["appModule"]["taskSolution"] && (_0x1bc047[_0x45ab0b(205)](_0x1bc047["gSHRS"], _0x45ab0b(175)) ? _0x16b089[_0x1bc047[_0x45ab0b(193)]] = this[_0x45ab0b(156)][_0x45ab0b(165)] : _0x29729a = _0x16490f[_0x45ab0b(186)]), _0x35b8c7 && (_0x16b089[_0x45ab0b(194)] = _0x1bc047[_0x45ab0b(190)]), { "TGA-Auth-Token": this[_0x45ab0b(156)][_0x45ab0b(178)](), "Content-Type": _0x1bc047[_0x45ab0b(182)], ..._0x16b089 };
      }
    }, this[_0x243438(156)] = _0x528f24, _0x1bc047[_0x243438(152)](this["appModule"][_0x243438(199)], _0x1bc047[_0x243438(166)]) && (this[_0x243438(168)] = STAGING_BACKEND_URL), !this["appModule"][_0x243438(178)]() && _0x1bc047[_0x243438(151)](throwError, Errors[_0x243438(146)]);
  }
  [_0x36945(162)]() {
  }
  async [_0x36945(169)](_0x13e827, _0x1f1689 = !![]) {
    const _0x3a5013 = _0x36945, _0x122a78 = { "PkFkd": function(_0x5c1fde, _0x3cb636, _0x7bd46) {
      return _0x5c1fde(_0x3cb636, _0x7bd46);
    }, "dzTin": function(_0x8ba1c9, _0x1c1144) {
      return _0x8ba1c9 + _0x1c1144;
    }, "krCXi": _0x3a5013(153), "TmUqJ": "POST", "qHNVK": function(_0x4e482e, _0x25b90a) {
      return _0x4e482e(_0x25b90a);
    } };
    return await _0x122a78["PkFkd"](fetch, _0x122a78[_0x3a5013(167)](this[_0x3a5013(168)], _0x122a78[_0x3a5013(154)]), { "method": _0x122a78[_0x3a5013(155)], "headers": this[_0x3a5013(170)](_0x1f1689), "body": _0x1f1689 ? await _0x122a78[_0x3a5013(210)](compressData, _0x13e827) : JSON[_0x3a5013(177)](_0x13e827) })[_0x3a5013(183)](this[_0x3a5013(179)], this["responseToParams"]);
  }
  async [_0x36945(185)](_0x479318, _0x147855, _0x22e4e5, _0x5222ed = !![]) {
    const _0x519b44 = _0x36945, _0x31ac9e = { "NExcc": _0x519b44(194), "RRCzb": "Content", "QwSqb": function(_0x2f292b, _0xbeb1f6) {
      return _0x2f292b === _0xbeb1f6;
    }, "TeoTU": function(_0x552798, _0x29c246) {
      return _0x552798 !== _0x29c246;
    }, "DliRF": _0x519b44(211), "DdNph": function(_0x58ee14, _0x506316) {
      return _0x58ee14 !== _0x506316;
    }, "oMpiO": _0x519b44(191), "iIacb": "POST", "Gpkut": function(_0x3d509d, _0x341385) {
      return _0x3d509d(_0x341385);
    } };
    (_0x147855 == null ? void 0 : _0x147855[_0x519b44(186)]) && (_0x31ac9e["QwSqb"](_0x519b44(207), _0x519b44(207)) ? !_0x22e4e5 ? _0x31ac9e[_0x519b44(173)](_0x31ac9e[_0x519b44(148)], _0x519b44(161)) ? _0x22e4e5 = _0x147855[_0x519b44(186)] : _0x324da6[_0x31ac9e[_0x519b44(174)]] = "gzip" : _0x31ac9e[_0x519b44(188)](_0x31ac9e[_0x519b44(158)], _0x31ac9e[_0x519b44(158)]) ? _0x5261c4[_0x31ac9e["RRCzb"]] = this[_0x519b44(156)][_0x519b44(165)] : _0x22e4e5 = Object["assign"](_0x147855[_0x519b44(186)], _0x22e4e5) : this["BACKEND_URL"] = _0x444c0b);
    const _0x257da0 = { ..._0x147855, "event_name": _0x479318, "custom_data": _0x22e4e5, ...this["appModule"][_0x519b44(160)]() };
    await fetch(this["BACKEND_URL"] + _0x519b44(153), { "method": _0x31ac9e[_0x519b44(197)], "headers": this[_0x519b44(170)](!![]), "body": _0x5222ed ? await _0x31ac9e["Gpkut"](compressData, _0x257da0) : JSON[_0x519b44(177)](_0x257da0) })[_0x519b44(183)](this[_0x519b44(179)], this[_0x519b44(179)]);
  }
}
class V extends Error {
  constructor(e, t, n) {
    super(t, { cause: n }), this.type = e, Object.setPrototypeOf(this, V.prototype);
  }
}
function f(s, e, t) {
  return new V(s, e, t);
}
const Ye = "ERR_UNEXPECTED_TYPE", ce = "ERR_PARSE";
function E() {
  return f(Ye, "Value has unexpected type");
}
class D {
  constructor(e, t, n) {
    this.parser = e, this.isOptional = t, this.type = n;
  }
  /**
   * Attempts to parse passed value
   * @param value - value to parse.
   * @throws {SDKError} ERR_PARSE
   * @see ERR_PARSE
   */
  parse(e) {
    if (!(this.isOptional && e === void 0))
      try {
        return this.parser(e);
      } catch (t) {
        throw f(
          ce,
          `Unable to parse value${this.type ? ` as ${this.type}` : ""}`,
          t
        );
      }
  }
  optional() {
    return this.isOptional = true, this;
  }
}
function S(s, e) {
  return () => new D(s, false, e);
}
const b = S((s) => {
  if (typeof s == "boolean")
    return s;
  const e = String(s);
  if (e === "1" || e === "true")
    return true;
  if (e === "0" || e === "false")
    return false;
  throw E();
}, "boolean");
function pe(s, e) {
  const t = {};
  for (const n in s) {
    const r = s[n];
    if (!r)
      continue;
    let i, o;
    if (typeof r == "function" || "parse" in r)
      i = n, o = typeof r == "function" ? r : r.parse.bind(r);
    else {
      const { type: a } = r;
      i = r.from || n, o = typeof a == "function" ? a : a.parse.bind(a);
    }
    try {
      const a = o(e(i));
      a !== void 0 && (t[n] = a);
    } catch (a) {
      throw f(ce, `Unable to parse field "${n}"`, a);
    }
  }
  return t;
}
function he(s) {
  let e = s;
  if (typeof e == "string" && (e = JSON.parse(e)), typeof e != "object" || e === null || Array.isArray(e))
    throw E();
  return e;
}
function g(s, e) {
  return new D((t) => {
    const n = he(t);
    return pe(s, (r) => n[r]);
  }, false, e);
}
const y = S((s) => {
  if (typeof s == "number")
    return s;
  if (typeof s == "string") {
    const e = Number(s);
    if (!Number.isNaN(e))
      return e;
  }
  throw E();
}, "number"), h = S((s) => {
  if (typeof s == "string" || typeof s == "number")
    return s.toString();
  throw E();
}, "string");
({
  custom_method_invoked: g({
    req_id: h(),
    result: (s) => s,
    error: h().optional()
  })
});
function Q(s) {
  return /^#[\da-f]{6}$/i.test(s);
}
function ht(s) {
  return /^#[\da-f]{3}$/i.test(s);
}
function me(s) {
  const e = s.replace(/\s/g, "").toLowerCase();
  if (Q(e))
    return e;
  if (ht(e)) {
    let n = "#";
    for (let r = 0; r < 3; r += 1)
      n += e[1 + r].repeat(2);
    return n;
  }
  const t = e.match(/^rgb\((\d{1,3}),(\d{1,3}),(\d{1,3})\)$/) || e.match(/^rgba\((\d{1,3}),(\d{1,3}),(\d{1,3}),\d{1,3}\)$/);
  if (!t)
    throw new Error(`Value "${s}" does not satisfy any of known RGB formats.`);
  return t.slice(1).reduce((n, r) => {
    const i = parseInt(r, 10).toString(16);
    return n + (i.length === 1 ? "0" : "") + i;
  }, "#");
}
const Ee = S((s) => s instanceof Date ? s : new Date(y().parse(s) * 1e3), "Date");
function K(s, e) {
  return new D((t) => {
    if (typeof t != "string" && !(t instanceof URLSearchParams))
      throw E();
    const n = typeof t == "string" ? new URLSearchParams(t) : t;
    return pe(s, (r) => {
      const i = n.get(r);
      return i === null ? void 0 : i;
    });
  }, false, e);
}
const dt = g({
  id: y(),
  type: h(),
  title: h(),
  photoUrl: {
    type: h().optional(),
    from: "photo_url"
  },
  username: h().optional()
}, "Chat").optional(), ne = g({
  addedToAttachmentMenu: {
    type: b().optional(),
    from: "added_to_attachment_menu"
  },
  allowsWriteToPm: {
    type: b().optional(),
    from: "allows_write_to_pm"
  },
  firstName: {
    type: h(),
    from: "first_name"
  },
  id: y(),
  isBot: {
    type: b().optional(),
    from: "is_bot"
  },
  isPremium: {
    type: b().optional(),
    from: "is_premium"
  },
  languageCode: {
    type: h().optional(),
    from: "language_code"
  },
  lastName: {
    type: h().optional(),
    from: "last_name"
  },
  photoUrl: {
    type: h().optional(),
    from: "photo_url"
  },
  username: h().optional()
}, "User").optional();
function Se() {
  return K({
    authDate: {
      type: Ee(),
      from: "auth_date"
    },
    canSendAfter: {
      type: y().optional(),
      from: "can_send_after"
    },
    chat: dt,
    chatInstance: {
      type: h().optional(),
      from: "chat_instance"
    },
    chatType: {
      type: h().optional(),
      from: "chat_type"
    },
    hash: h(),
    queryId: {
      type: h().optional(),
      from: "query_id"
    },
    receiver: ne,
    startParam: {
      type: h().optional(),
      from: "start_param"
    },
    user: ne
  }, "InitData");
}
const _t = S((s) => me(h().parse(s)), "rgb");
function ft(s) {
  return s.replace(/_[a-z]/g, (e) => e[1].toUpperCase());
}
function gt(s) {
  return s.replace(/[A-Z]/g, (e) => `_${e.toLowerCase()}`);
}
const Pe = S(
  (s) => {
    const e = _t().optional();
    return Object.entries(he(s)).reduce((t, [n, r]) => (t[ft(n)] = e.parse(r), t), {});
  },
  "ThemeParams"
);
function X(s) {
  return K({
    botInline: {
      type: b().optional(),
      from: "tgWebAppBotInline"
    },
    initData: {
      type: Se().optional(),
      from: "tgWebAppData"
    },
    initDataRaw: {
      type: h().optional(),
      from: "tgWebAppData"
    },
    platform: {
      type: h(),
      from: "tgWebAppPlatform"
    },
    showSettings: {
      type: b().optional(),
      from: "tgWebAppShowSettings"
    },
    startParam: {
      type: h().optional(),
      from: "tgWebAppStartParam"
    },
    themeParams: {
      type: Pe(),
      from: "tgWebAppThemeParams"
    },
    version: {
      type: h(),
      from: "tgWebAppVersion"
    }
  }).parse(s);
}
function xe(s) {
  return X(
    s.replace(/^[^?#]*[?#]/, "").replace(/[?#]/g, "&")
  );
}
function wt() {
  return xe(window.location.href);
}
function Ce() {
  return performance.getEntriesByType("navigation")[0];
}
function bt() {
  const s = Ce();
  if (!s)
    throw new Error("Unable to get first navigation entry.");
  return xe(s.name);
}
function Te(s) {
  return `telegram-apps/${s.replace(/[A-Z]/g, (e) => `-${e.toLowerCase()}`)}`;
}
function Re(s, e) {
  sessionStorage.setItem(Te(s), JSON.stringify(e));
}
function Ae(s) {
  const e = sessionStorage.getItem(Te(s));
  try {
    return e ? JSON.parse(e) : void 0;
  } catch {
  }
}
function mt() {
  return X(Ae("launchParams") || "");
}
function Ie(s) {
  return JSON.stringify(
    Object.fromEntries(
      Object.entries(s).map(([e, t]) => [gt(e), t])
    )
  );
}
function yt(s) {
  const {
    initDataRaw: e,
    themeParams: t,
    platform: n,
    version: r,
    showSettings: i,
    startParam: o,
    botInline: a
  } = s, p = new URLSearchParams();
  return p.set("tgWebAppPlatform", n), p.set("tgWebAppThemeParams", Ie(t)), p.set("tgWebAppVersion", r), e && p.set("tgWebAppData", e), o && p.set("tgWebAppStartParam", o), typeof i == "boolean" && p.set("tgWebAppShowSettings", i ? "1" : "0"), typeof a == "boolean" && p.set("tgWebAppBotInline", a ? "1" : "0"), p.toString();
}
function qe(s) {
  Re("launchParams", yt(s));
}
function vt() {
  const s = [];
  for (const e of [
    // Try to retrieve launch parameters from the current location. This method can return
    // nothing in case, location was changed, and then the page was reloaded.
    wt,
    // Then, try using the lower level API - window.performance.
    bt,
    // Finally, try to extract launch parameters from the session storage.
    mt
  ])
    try {
      const t = e();
      return qe(t), t;
    } catch (t) {
      s.push(t instanceof Error ? t.message : JSON.stringify(t));
    }
  throw new Error([
    `Unable to retrieve launch parameters from any known source. Perhaps, you have opened your app outside Telegram?
`,
    "📖 Refer to docs for more information:",
    `https://docs.telegram-mini-apps.com/packages/telegram-apps-sdk/environment
`,
    "Collected errors:",
    s.map((e) => `— ${e}`)
  ].join(`
`));
}
(function(_0x30cc10, _0x5a2cb9) {
  const _0x13a704 = _0x4974, _0x3242d1 = _0x30cc10();
  while (!![]) {
    try {
      const _0x2312b9 = -parseInt(_0x13a704(460)) / 1 * (parseInt(_0x13a704(448)) / 2) + -parseInt(_0x13a704(443)) / 3 * (parseInt(_0x13a704(451)) / 4) + parseInt(_0x13a704(469)) / 5 + -parseInt(_0x13a704(463)) / 6 + parseInt(_0x13a704(465)) / 7 + parseInt(_0x13a704(452)) / 8 * (-parseInt(_0x13a704(462)) / 9) + -parseInt(_0x13a704(461)) / 10 * (-parseInt(_0x13a704(457)) / 11);
      if (_0x2312b9 === _0x5a2cb9) break;
      else _0x3242d1["push"](_0x3242d1["shift"]());
    } catch (_0x3bb6bb) {
      _0x3242d1["push"](_0x3242d1["shift"]());
    }
  }
})(_0x490e, 276244);
function _0x4974(_0x1a11ce, _0x2d3038) {
  const _0x490e66 = _0x490e();
  return _0x4974 = function(_0x4974af, _0x143bd8) {
    _0x4974af = _0x4974af - 443;
    let _0x3a290f = _0x490e66[_0x4974af];
    return _0x3a290f;
  }, _0x4974(_0x1a11ce, _0x2d3038);
}
function _0x490e() {
  const _0x3e5cf6 = ["LcZkW", "slice", "71159RSkMof", "length", "charCodeAt", "42572KBdaUn", "1460JcnZlR", "188289dgglFv", "1470144OIxlqi", "biVwh", "1239973mnQhtF", "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx", "FcOuv", "LRUAQ", "558555IYwHRg", "toString", "CBYCL", "1461GkWtgd", "SkQHQ", "qKnpY", "oksJL", "LZfTF", "20XxHZBP", "vlKyb", "ruJdt", "2180jlpktx", "8SWKoEb", "getTime", "oJuZJ"];
  _0x490e = function() {
    return _0x3e5cf6;
  };
  return _0x490e();
}
function generateUUID(_0x5c7f73) {
  const _0x48441b = _0x4974, _0xe0e505 = { "LRUAQ": function(_0x338125, _0x13025a) {
    return _0x338125 + _0x13025a;
  }, "SkQHQ": function(_0x1644f6, _0x1bceda) {
    return _0x1644f6 - _0x1bceda;
  }, "FcOuv": function(_0xeed4cc, _0x14e569) {
    return _0xeed4cc << _0x14e569;
  }, "biVwh": function(_0x235bb7, _0x280b6e) {
    return _0x235bb7 % _0x280b6e;
  }, "LcZkW": function(_0x1bf0e3, _0x2e38c1) {
    return _0x1bf0e3 + _0x2e38c1;
  }, "ruJdt": function(_0x2f510a, _0x18a631, _0x203f60) {
    return _0x2f510a(_0x18a631, _0x203f60);
  }, "vlKyb": function(_0x5cf32e, _0x8d0d51) {
    return _0x5cf32e / _0x8d0d51;
  }, "CBYCL": function(_0x53d9a2, _0x4d114f) {
    return _0x53d9a2 == _0x4d114f;
  }, "LZfTF": function(_0x22b5ea, _0x53eff6) {
    return _0x22b5ea | _0x53eff6;
  }, "oksJL": function(_0x58b234, _0x4c1b54) {
    return _0x58b234 & _0x4c1b54;
  }, "TSoKi": _0x48441b(466), "qKnpY": function(_0x5c7e65, _0x1f0214) {
    return _0x5c7e65(_0x1f0214);
  }, "oJuZJ": function(_0x28ff2e, _0x1e0dc3) {
    return _0x28ff2e < _0x1e0dc3;
  } };
  let _0x544995 = _0xe0e505["TSoKi"], _0x5404ae = (/* @__PURE__ */ new Date())[_0x48441b(453)]();
  const _0x437aa0 = _0x5c7f73 + _0x5404ae;
  function _0x350d4f(_0x5f4e81) {
    const _0x82f52c = _0x48441b;
    let _0x5471b4 = 0;
    for (let _0x524a66 = 0; _0x524a66 < _0x5f4e81["length"]; _0x524a66++) {
      const _0x2c039f = _0x5f4e81[_0x82f52c(459)](_0x524a66);
      _0x5471b4 = _0xe0e505[_0x82f52c(468)](_0xe0e505[_0x82f52c(444)](_0xe0e505[_0x82f52c(467)](_0x5471b4, 5), _0x5471b4), _0x2c039f), _0x5471b4 |= 0;
    }
    return _0x5471b4;
  }
  let _0x2ce35d = _0xe0e505[_0x48441b(445)](_0x350d4f, _0x437aa0)[_0x48441b(470)](16);
  while (_0xe0e505[_0x48441b(454)](_0x2ce35d[_0x48441b(458)], 32)) {
    _0x2ce35d += _0x2ce35d;
  }
  _0x2ce35d = _0x2ce35d[_0x48441b(456)](0, 32);
  let _0x41c8fd = 0;
  return _0x544995["replace"](/[xy]/g, function(_0x2f27c3) {
    const _0x43fda5 = _0x48441b, _0x380098 = _0xe0e505[_0x43fda5(464)](_0xe0e505[_0x43fda5(455)](_0x5404ae, _0xe0e505[_0x43fda5(450)](parseInt, _0x2ce35d[_0x41c8fd], 16)), 16) | 0;
    return _0x5404ae = Math["floor"](_0xe0e505[_0x43fda5(449)](_0x5404ae, 16)), _0x41c8fd++, (_0xe0e505[_0x43fda5(471)](_0x2f27c3, "x") ? _0x380098 : _0xe0e505[_0x43fda5(447)](_0xe0e505[_0x43fda5(446)](_0x380098, 3), 8))[_0x43fda5(470)](16);
  });
}
const _0x5da91b = _0x1ab4;
function _0x1ab4(_0x4ecc4a, _0x5eb84e) {
  const _0x2d2e08 = _0x2d2e();
  return _0x1ab4 = function(_0x1ab433, _0x59a0ef) {
    _0x1ab433 = _0x1ab433 - 232;
    let _0x18d024 = _0x2d2e08[_0x1ab433];
    return _0x18d024;
  }, _0x1ab4(_0x4ecc4a, _0x5eb84e);
}
(function(_0x2a071c, _0x1bd155) {
  const _0x579b39 = _0x1ab4, _0xfd7bb0 = _0x2a071c();
  while (!![]) {
    try {
      const _0x25b028 = parseInt(_0x579b39(265)) / 1 + -parseInt(_0x579b39(243)) / 2 + -parseInt(_0x579b39(252)) / 3 + parseInt(_0x579b39(235)) / 4 * (-parseInt(_0x579b39(248)) / 5) + parseInt(_0x579b39(233)) / 6 * (parseInt(_0x579b39(238)) / 7) + -parseInt(_0x579b39(236)) / 8 + parseInt(_0x579b39(244)) / 9;
      if (_0x25b028 === _0x1bd155) break;
      else _0xfd7bb0["push"](_0xfd7bb0["shift"]());
    } catch (_0x542eec) {
      _0xfd7bb0["push"](_0xfd7bb0["shift"]());
    }
  }
})(_0x2d2e, 715589);
function _0x2d2e() {
  const _0x3578f6 = ["startParam", "getUserIsPremium", "XIJeb", "userLocale", "init", "lUlMs", "platform", "UTVgo", "webAppStartParam", "firstName", "lastName", "341630hLGdRB", "iRkMG", "getUserData", "getPlatform", "assembleEventSession", "MtJUb", "is_premium", "sessionId", "isPremium", "username", "languageCode", "getUserId", "userId", "6rUQgfd", "now", "6276wxgKtE", "5457432OqKtWJ", "USER_DATA_IS_NOT_PROVIDED", "512939yxopFv", "getAppName", "pHmLW", "initData", "getWebAppStartParam", "2311388eSPhAi", "31837527IdpJcV", "NoPSn", "userData", "user", "2635CpYkNI", "photoUrl", "getSessionId", "getUserLocale", "1716255OqVlWU", "appModule"];
  _0x2d2e = function() {
    return _0x3578f6;
  };
  return _0x2d2e();
}
class SessionController {
  constructor(_0x2fa2d9) {
    const _0x1ffb92 = _0x1ab4;
    this[_0x1ffb92(253)] = _0x2fa2d9;
  }
  [_0x5da91b(258)]() {
    var _a, _b;
    const _0x1f56b2 = _0x5da91b, _0x4a7516 = { "DXFXy": function(_0x43d14e, _0x5804e5) {
      return _0x43d14e(_0x5804e5);
    }, "UTVgo": function(_0x5555b3, _0x4879f3) {
      return _0x5555b3(_0x4879f3);
    }, "pHmLW": function(_0x590bd0) {
      return _0x590bd0();
    }, "uIZPR": function(_0x2d02f5, _0x405c22) {
      return _0x2d02f5 === _0x405c22;
    }, "iRkMG": _0x1f56b2(245), "XIJeb": function(_0x197c26, _0x564f56) {
      return _0x197c26(_0x564f56);
    }, "MtJUb": function(_0x3d3ac, _0x260a7d) {
      return _0x3d3ac(_0x260a7d);
    } }, _0x1f72c3 = _0x4a7516[_0x1f56b2(240)](vt), _0x5f3c03 = _0x1f72c3[_0x1f56b2(241)], _0x57dfbe = (_a = _0x1f72c3[_0x1f56b2(241)]) == null ? void 0 : _a[_0x1f56b2(247)];
    if (!_0x57dfbe) {
      if (_0x4a7516["uIZPR"](_0x4a7516[_0x1f56b2(266)], _0x4a7516["iRkMG"])) _0x4a7516[_0x1f56b2(256)](throwError, Errors["USER_DATA_IS_NOT_PROVIDED"]);
      else {
        const _0x347d68 = _0x1bb2ae(), _0x1087c5 = _0x347d68[_0x1f56b2(241)], _0x189960 = (_b = _0x347d68[_0x1f56b2(241)]) == null ? void 0 : _b[_0x1f56b2(247)];
        !_0x189960 && _0x5a5e75(_0x375b1a[_0x1f56b2(237)]), this[_0x1f56b2(246)] = { "id": _0x189960["id"], "is_premium": _0x189960[_0x1f56b2(273)], "first_name": _0x189960[_0x1f56b2(263)], "is_bot": _0x189960["isBot"], "last_name": _0x189960[_0x1f56b2(264)], "language_code": _0x189960["languageCode"], "photo_url": _0x189960["photoUrl"], "username": _0x189960[_0x1f56b2(274)] }, this[_0x1f56b2(232)] = _0x189960["id"], this[_0x1f56b2(257)] = _0x189960["languageCode"], this[_0x1f56b2(262)] = _0x1087c5[_0x1f56b2(254)], this["platform"] = _0x347d68["platform"], this[_0x1f56b2(272)] = _0x4a7516["DXFXy"](_0x477f07, _0x4a7516[_0x1f56b2(261)](_0x3b4f1a, this[_0x1f56b2(276)]()));
      }
    }
    this[_0x1f56b2(246)] = { "id": _0x57dfbe["id"], "is_premium": _0x57dfbe[_0x1f56b2(273)], "first_name": _0x57dfbe["firstName"], "is_bot": _0x57dfbe["isBot"], "last_name": _0x57dfbe["lastName"], "language_code": _0x57dfbe["languageCode"], "photo_url": _0x57dfbe[_0x1f56b2(249)], "username": _0x57dfbe[_0x1f56b2(274)] }, this[_0x1f56b2(232)] = _0x57dfbe["id"], this[_0x1f56b2(257)] = _0x57dfbe[_0x1f56b2(275)], this[_0x1f56b2(262)] = _0x5f3c03["startParam"], this[_0x1f56b2(260)] = _0x1f72c3[_0x1f56b2(260)], this[_0x1f56b2(272)] = _0x4a7516[_0x1f56b2(261)](generateUUID, _0x4a7516[_0x1f56b2(270)](String, this["getUserId"]()));
  }
  [_0x5da91b(250)]() {
    return this["sessionId"];
  }
  [_0x5da91b(276)]() {
    const _0x5c1c38 = _0x5da91b;
    return this[_0x5c1c38(232)];
  }
  [_0x5da91b(242)]() {
    const _0x21c76d = _0x5da91b;
    return this[_0x21c76d(262)];
  }
  [_0x5da91b(268)]() {
    return this["platform"];
  }
  [_0x5da91b(251)]() {
    const _0x33267b = _0x5da91b;
    return this[_0x33267b(257)];
  }
  [_0x5da91b(267)]() {
    const _0xf5e9b6 = _0x5da91b;
    return this[_0xf5e9b6(246)];
  }
  [_0x5da91b(255)]() {
    const _0x16af23 = _0x5da91b, _0x2cc98d = this[_0x16af23(267)]();
    return Boolean(_0x2cc98d == null ? void 0 : _0x2cc98d[_0x16af23(271)]);
  }
  [_0x5da91b(269)]() {
    const _0x1d2790 = _0x5da91b, _0xd97059 = { "lUlMs": function(_0x1416ce, _0x1cd45c) {
      return _0x1416ce(_0x1cd45c);
    } };
    return { "session_id": this[_0x1d2790(250)](), "user_id": this[_0x1d2790(276)](), "app_name": this["appModule"][_0x1d2790(239)](), "is_premium": this[_0x1d2790(255)](), "platform": this[_0x1d2790(268)](), "locale": this[_0x1d2790(251)](), "start_param": this[_0x1d2790(242)](), "client_timestamp": _0xd97059[_0x1d2790(259)](String, Date[_0x1d2790(234)]()) };
  }
}
function _0x27fb() {
  const _0x22fcd3 = ["1334580ASQDHL", "findIndex", "getBatch", "27zkVxMP", "null", "354550OsQZdv", "parse", "localStorage", "key", "stringify", "4877590CXgbCR", "setItem", "1163478WTWOFw", "addToStorage", "1104316FjUkcL", "includes", "672836gESYxP", "dJNGk", "sessionStorage", "1991661jThIDx", "32akvbeh", "getItem", "filter", "1TTUyIS"];
  _0x27fb = function() {
    return _0x22fcd3;
  };
  return _0x27fb();
}
function _0x15f2(_0x1f9329, _0x23f8db) {
  const _0x27fb72 = _0x27fb();
  return _0x15f2 = function(_0x15f2cb, _0x11a6af) {
    _0x15f2cb = _0x15f2cb - 115;
    let _0x52fa72 = _0x27fb72[_0x15f2cb];
    return _0x52fa72;
  }, _0x15f2(_0x1f9329, _0x23f8db);
}
const _0x54fdd8 = _0x15f2;
(function(_0x5c43b4, _0xffa740) {
  const _0xfd739a = _0x15f2, _0x50945a = _0x5c43b4();
  while (!![]) {
    try {
      const _0x474ea5 = parseInt(_0xfd739a(129)) / 1 * (-parseInt(_0xfd739a(120)) / 2) + -parseInt(_0xfd739a(125)) / 3 + -parseInt(_0xfd739a(122)) / 4 + parseInt(_0xfd739a(130)) / 5 + parseInt(_0xfd739a(118)) / 6 + parseInt(_0xfd739a(135)) / 7 * (-parseInt(_0xfd739a(126)) / 8) + -parseInt(_0xfd739a(133)) / 9 * (-parseInt(_0xfd739a(116)) / 10);
      if (_0x474ea5 === _0xffa740) break;
      else _0x50945a["push"](_0x50945a["shift"]());
    } catch (_0x16bb31) {
      _0x50945a["push"](_0x50945a["shift"]());
    }
  }
})(_0x27fb, 337252);
class BatchStorage {
  constructor(_0x3d4090) {
    const _0x446b85 = _0x15f2;
    this["sessionStorage"] = window["sessionStorage"], this[_0x446b85(137)] = window["localStorage"], this["key"] = _0x3d4090;
  }
  [_0x54fdd8(132)]() {
    const _0x237d59 = _0x54fdd8, _0xd17c0c = { "dJNGk": _0x237d59(134) };
    return [null, _0xd17c0c[_0x237d59(123)]][_0x237d59(121)](this[_0x237d59(124)][_0x237d59(127)](this[_0x237d59(138)])) && [null, _0xd17c0c["dJNGk"]][_0x237d59(121)](this["localStorage"]["getItem"](this["key"])) ? this[_0x237d59(117)]([]) : this[_0x237d59(117)](JSON[_0x237d59(136)](this["localStorage"][_0x237d59(127)](this[_0x237d59(138)]))), this[_0x237d59(117)]([...JSON["parse"](this[_0x237d59(124)][_0x237d59(127)](this[_0x237d59(138)])), ...JSON[_0x237d59(136)](this[_0x237d59(137)][_0x237d59(127)](this["key"]))][_0x237d59(128)]((_0x3c57c6, _0x461562, _0x27f5ab) => _0x27f5ab[_0x237d59(131)]((_0xc24de) => JSON[_0x237d59(115)](_0xc24de) === JSON[_0x237d59(115)](_0x3c57c6)) === _0x461562)), JSON[_0x237d59(136)](this[_0x237d59(124)][_0x237d59(127)](this[_0x237d59(138)]));
  }
  [_0x54fdd8(119)](_0x975eb8, _0x3585d9) {
    const _0x1d0d0b = _0x54fdd8, _0x47501a = this[_0x1d0d0b(132)]();
    _0x47501a["push"]({ "event_name": _0x975eb8, ..._0x3585d9 }), this[_0x1d0d0b(117)](_0x47501a);
  }
  [_0x54fdd8(117)](_0x13e08b) {
    const _0x2c8047 = _0x54fdd8;
    this[_0x2c8047(137)][_0x2c8047(117)](this[_0x2c8047(138)], JSON[_0x2c8047(115)](_0x13e08b)), this["sessionStorage"]["setItem"](this[_0x2c8047(138)], JSON[_0x2c8047(115)](_0x13e08b));
  }
}
function _0x12df(_0x9b6ed2, _0x5a7312) {
  const _0x45e6fe = _0x45e6();
  return _0x12df = function(_0x12dffe, _0x3d65cf) {
    _0x12dffe = _0x12dffe - 399;
    let _0x3152ee = _0x45e6fe[_0x12dffe];
    return _0x3152ee;
  }, _0x12df(_0x9b6ed2, _0x5a7312);
}
function _0x45e6() {
  const _0x47f47f = ["tFxfj", "LfBiN", "CuQXT", "231UeFTLT", "2033297XEZvog", "fMLsR", "getBatch", "zkWYc", "xPojB", "intervalId", "NHLKy", "JihvB", "init", "JLOrP", "zraPh", "batchInterval", "fgQNr", "BATCH_KEY", "setInterval", "18rEVrHq", "UGqxp", "stopBatching", "rXMTx", "9szwHbQ", "uQQyC", "uZQTB", "setItem", "429", "DVgjG", "oOZbH", "onLine", "load", "xocaE", "sendBatch", "xKyzD", "CRukg", "hLFrU", "106260YZMjBh", "FDjEn", "FsoYm", "hUDPt", "jwAWC", "652748eTApsC", "rgIPU", "cuMIf", "processQueue", "appModule", "addToStorage", "stringify", "203", "ymUsB", "ZSVlB", "478251VySMei", "oVeww", "getApiToken", "rFFfd", "taskSolution", "backoff", "DXKjb", "storage", "xTpgj", "AftEK", "FZbhz", "Uypsg", "INIT", "vTOdJ", "uDBpe", "1|4|3|2|5|0|6", "startBatchingWithInterval", "DRTBq", "Xksjz", "2463vINQZC", "collectEvent", "some", "kmoLS", "solveTask", "qzbuE", "collect", "YuyDN", "1194696rWbEfU", "then", "DBvmG", "rgskA", "readyState", "LxhqG", "slice", "onreadystatechange", "wsNbF", "ZKQTV", "DLolS", "254VhnwQk", "20tpodCH", "15889284ORNvXp", "xXHKj", "length", "complete", "RDbLv", "taskRetry", "uvrbu", "PQMBf", "startBatching", "UKfKj", "UiUVR", "status", "FSZpj"];
  _0x45e6 = function() {
    return _0x47f47f;
  };
  return _0x45e6();
}
const _0x11291f = _0x12df;
(function(_0x6ab147, _0x1ccb6d) {
  const _0x543cc9 = _0x12df, _0x371d05 = _0x6ab147();
  while (!![]) {
    try {
      const _0x522a4c = parseInt(_0x543cc9(412)) / 1 + parseInt(_0x543cc9(450)) / 2 * (parseInt(_0x543cc9(431)) / 3) + parseInt(_0x543cc9(402)) / 4 * (-parseInt(_0x543cc9(451)) / 5) + parseInt(_0x543cc9(484)) / 6 * (-parseInt(_0x543cc9(469)) / 7) + -parseInt(_0x543cc9(439)) / 8 * (parseInt(_0x543cc9(488)) / 9) + -parseInt(_0x543cc9(502)) / 10 * (-parseInt(_0x543cc9(468)) / 11) + parseInt(_0x543cc9(452)) / 12;
      if (_0x522a4c === _0x1ccb6d) break;
      else _0x371d05["push"](_0x371d05["shift"]());
    } catch (_0x4ac964) {
      _0x371d05["push"](_0x371d05["shift"]());
    }
  }
})(_0x45e6, 456273);
class BatchService {
  constructor(_0x3dd67e) {
    const _0xd8eab9 = _0x12df, _0x126440 = { "erSOw": _0xd8eab9(427), "qzbuE": function(_0xc20a86, _0x8b856e) {
      return _0xc20a86 + _0x8b856e;
    }, "iNmFh": function(_0x274053, _0x1ab950) {
      return _0x274053 + _0x1ab950;
    } }, _0x3b1562 = _0x126440["erSOw"]["split"]("|");
    let _0x2cd47f = 0;
    while (!![]) {
      switch (_0x3b1562[_0x2cd47f++]) {
        case "0":
          this[_0xd8eab9(406)] = _0x3dd67e;
          continue;
        case "1":
          this[_0xd8eab9(417)] = 1;
          continue;
        case "2":
          this[_0xd8eab9(457)] = 0;
          continue;
        case "3":
          this[_0xd8eab9(480)] = 2e3;
          continue;
        case "4":
          this[_0xd8eab9(474)] = null;
          continue;
        case "5":
          this[_0xd8eab9(482)] = BATCH_KEY;
          continue;
        case "6":
          this["storage"] = new BatchStorage(_0x126440[_0xd8eab9(436)](_0x126440["iNmFh"](this[_0xd8eab9(482)], "-"), this[_0xd8eab9(406)][_0xd8eab9(414)]()));
          continue;
      }
      break;
    }
  }
  [_0x11291f(477)]() {
    const _0x252a45 = _0x11291f, _0x2148bc = { "FodLz": function(_0x11b183, _0x17344a) {
      return _0x11b183 == _0x17344a;
    }, "JihvB": _0x252a45(455), "Uypsg": function(_0x14ab50, _0x25247a) {
      return _0x14ab50 === _0x25247a;
    }, "YuyDN": _0x252a45(466), "ZSVlB": function(_0x196aed, _0x3d6446) {
      return _0x196aed === _0x3d6446;
    }, "nDZIt": "DSAPm", "zkWYc": function(_0x5009ee, _0xc0d78b) {
      return _0x5009ee !== _0xc0d78b;
    }, "rXMTx": _0x252a45(422), "UiUVR": _0x252a45(478) };
    _0x2148bc[_0x252a45(423)](document[_0x252a45(443)], _0x2148bc["JihvB"]) ? _0x2148bc[_0x252a45(411)](_0x252a45(400), _0x2148bc["nDZIt"]) ? this[_0x252a45(419)][_0x252a45(407)](_0x3d6c5a, _0x38f65a) : this[_0x252a45(428)]() : _0x2148bc[_0x252a45(472)](_0x2148bc[_0x252a45(487)], _0x2148bc[_0x252a45(462)]) ? document[_0x252a45(446)] = () => {
      const _0x3953f9 = _0x252a45;
      _0x2148bc["FodLz"](document[_0x3953f9(443)], _0x2148bc[_0x3953f9(476)]) && (_0x2148bc[_0x3953f9(423)](_0x3953f9(399), _0x2148bc[_0x3953f9(438)]) ? this[_0x3953f9(498)](_0x523f52[_0x3953f9(445)](0, 20)) : this[_0x3953f9(428)]());
    } : (this[_0x252a45(460)](), _0x494951(_0x23aac8));
  }
  ["startBatchingWithInterval"]() {
    const _0x49e75f = _0x11291f, _0x2c1a5c = { "PQMBf": function(_0x52eced, _0x1dda98) {
      return _0x52eced >= _0x1dda98;
    }, "FqPgE": function(_0x17ade7, _0x48828f) {
      return _0x17ade7(_0x48828f);
    }, "DLolS": function(_0x28b620, _0x308d25) {
      return _0x28b620 !== _0x308d25;
    }, "ZKQTV": function(_0x46e62e, _0x53a43e) {
      return _0x46e62e === _0x53a43e;
    }, "kmoLS": _0x49e75f(481), "kByNs": _0x49e75f(489), "AftEK": function(_0x372778, _0x216ebf) {
      return _0x372778(_0x216ebf);
    }, "MVKDo": function(_0x7f4bfb, _0x1a6633) {
      return _0x7f4bfb !== _0x1a6633;
    }, "ymUsB": function(_0x1bc122, _0x3a4881, _0x1ec389) {
      return _0x1bc122(_0x3a4881, _0x1ec389);
    } };
    let _0x4c6b69 = 0;
    this[_0x49e75f(406)][_0x49e75f(435)](), this["appModule"][_0x49e75f(432)](Events[_0x49e75f(424)]);
    if (_0x2c1a5c["MVKDo"](this[_0x49e75f(406)][_0x49e75f(416)], void 0)) this["startBatching"]();
    else {
      const _0x81683d = _0x2c1a5c[_0x49e75f(410)](setInterval, () => {
        const _0x3ff0a6 = _0x49e75f, _0x8ee5eb = { "aeFFS": function(_0x44c8b0, _0x5e8029) {
          const _0x51870d = _0x12df;
          return _0x2c1a5c[_0x51870d(459)](_0x44c8b0, _0x5e8029);
        }, "vTOdJ": function(_0x25e64c, _0x8d9b54) {
          return _0x2c1a5c["FqPgE"](_0x25e64c, _0x8d9b54);
        } };
        if (_0x2c1a5c[_0x3ff0a6(449)](this[_0x3ff0a6(406)][_0x3ff0a6(416)], void 0)) this["startBatching"](), clearInterval(_0x81683d);
        else {
          if (_0x2c1a5c[_0x3ff0a6(448)](_0x2c1a5c[_0x3ff0a6(434)], _0x2c1a5c["kByNs"])) {
            if (_0x8ee5eb["aeFFS"](_0x565bc6++, 3)) {
              this[_0x3ff0a6(460)](), _0x8ee5eb[_0x3ff0a6(425)](_0x4c68f8, _0xa444d8);
              return;
            }
            this[_0x3ff0a6(406)][_0x3ff0a6(435)]();
          } else {
            if (_0x4c6b69++ >= 3) {
              this["startBatching"](), _0x2c1a5c[_0x3ff0a6(421)](clearInterval, _0x81683d);
              return;
            }
            this["appModule"][_0x3ff0a6(435)]();
          }
        }
      }, 1e3);
    }
  }
  ["stopBatching"]() {
    const _0x4e4fdb = _0x11291f, _0x1fdcc1 = { "Xksjz": function(_0x8f2316, _0x409bc8) {
      return _0x8f2316(_0x409bc8);
    } };
    this[_0x4e4fdb(474)] !== null && (_0x1fdcc1[_0x4e4fdb(430)](clearInterval, this[_0x4e4fdb(474)]), this[_0x4e4fdb(474)] = null);
  }
  [_0x11291f(437)](_0x1d9093, _0x44eb13) {
    const _0x207949 = _0x11291f, _0x3f49a3 = { "CuQXT": function(_0x3858b5) {
      return _0x3858b5();
    }, "UGqxp": function(_0x4ef8f2, _0x2d9f6a) {
      return _0x4ef8f2 === _0x2d9f6a;
    }, "NHLKy": "tYNrx", "vPabo": function(_0x4c3bfd, _0x226318) {
      return _0x4c3bfd === _0x226318;
    }, "uvrbu": _0x207949(455), "uZQTB": function(_0x4625e4, _0x3e3bdf) {
      return _0x4625e4 !== _0x3e3bdf;
    }, "fMLsR": _0x207949(429), "qGKUg": _0x207949(496), "xocaE": function(_0x52433a, _0x2a4180) {
      return _0x52433a === _0x2a4180;
    }, "oVeww": _0x207949(493), "tFxfj": function(_0x404ec3, _0x40af48, _0x1d76fd) {
      return _0x404ec3(_0x40af48, _0x1d76fd);
    } };
    if (_0x3f49a3[_0x207949(497)](document["readyState"], _0x3f49a3[_0x207949(458)])) this[_0x207949(419)][_0x207949(407)](_0x1d9093, _0x44eb13);
    else {
      if (_0x3f49a3[_0x207949(485)](_0x207949(500), _0x3f49a3[_0x207949(413)])) {
        this[_0x207949(460)](), _0x5c7c0a(_0x55008e);
        return;
      } else {
        const _0x520d98 = () => {
          const _0x407213 = _0x207949, _0x55f3c1 = { "FSZpj": function(_0x7385bc) {
            const _0x1618cc = _0x12df;
            return _0x3f49a3[_0x1618cc(467)](_0x7385bc);
          } };
          _0x3f49a3[_0x407213(485)](_0x3f49a3[_0x407213(475)], _0x3f49a3[_0x407213(475)]) ? this[_0x407213(419)][_0x407213(407)](_0x1d9093, _0x44eb13) : _0x55f3c1[_0x407213(464)](_0x4e13fb);
        };
        _0x3f49a3[_0x207949(465)](setTimeout, () => {
          const _0x294d35 = _0x207949;
          _0x3f49a3["vPabo"]("FBazO", _0x294d35(401)) ? (this[_0x294d35(417)]++, this[_0x294d35(480)] = this[_0x294d35(480)] * 2.71, this[_0x294d35(460)]()) : _0x3f49a3[_0x294d35(485)](document[_0x294d35(443)], _0x3f49a3[_0x294d35(458)]) ? _0x3f49a3[_0x294d35(490)](_0x3f49a3[_0x294d35(470)], "DRTBq") ? this["storage"]["addToStorage"](_0x309834, _0x46ba0a) : _0x3f49a3[_0x294d35(467)](_0x520d98) : window["addEventListener"](_0x3f49a3["qGKUg"], _0x520d98);
        }, 0);
      }
    }
  }
  [_0x11291f(460)]() {
    const _0x5577b3 = _0x11291f, _0x3e7db8 = { "bwOLn": function(_0x3b3deb, _0x56b740) {
      return _0x3b3deb(_0x56b740);
    }, "FDjEn": function(_0x5d19e3, _0x4a54f8) {
      return _0x5d19e3 === _0x4a54f8;
    }, "cuMIf": function(_0x5acc43, _0xf97a90) {
      return _0x5acc43 !== _0xf97a90;
    }, "RDbLv": "MNDir", "LxhqG": _0x5577b3(494) };
    this["appModule"]["solveTask"](), _0x3e7db8[_0x5577b3(503)](this[_0x5577b3(474)], null) && (_0x3e7db8[_0x5577b3(404)](_0x3e7db8[_0x5577b3(456)], _0x3e7db8[_0x5577b3(444)]) ? this[_0x5577b3(474)] = window[_0x5577b3(483)](() => this[_0x5577b3(405)](), this[_0x5577b3(480)]) : (_0x3e7db8["bwOLn"](_0x3db9bc, this[_0x5577b3(474)]), this[_0x5577b3(474)] = null));
  }
  [_0x11291f(405)]() {
    const _0x33c188 = _0x11291f, _0x29acb2 = { "zraPh": _0x33c188(496), "hLFrU": function(_0x3138df, _0x4361d5) {
      return _0x3138df !== _0x4361d5;
    }, "rgskA": function(_0x3d71c8, _0x3d424b) {
      return _0x3d71c8 !== _0x3d424b;
    }, "DXKjb": _0x33c188(461), "xXHKj": "wGRtV" }, _0x49fea4 = this[_0x33c188(419)][_0x33c188(471)]();
    _0x29acb2[_0x33c188(501)](_0x49fea4[_0x33c188(454)], 0) && window["navigator"][_0x33c188(495)] && (_0x29acb2[_0x33c188(442)](_0x29acb2[_0x33c188(418)], _0x29acb2[_0x33c188(453)]) ? this["sendBatch"](_0x49fea4["slice"](0, 20)) : _0x4337ef["addEventListener"](_0x29acb2[_0x33c188(479)], _0x32897d));
  }
  [_0x11291f(498)](_0x3a7de7) {
    const _0x42e3f8 = _0x11291f, _0xc6e966 = { "xTpgj": function(_0x57aead, _0x1b5e51) {
      return _0x57aead === _0x1b5e51;
    }, "wsNbF": function(_0x31978f, _0x18d2b3) {
      return _0x31978f(_0x18d2b3);
    }, "rFFfd": _0x42e3f8(492), "rgIPU": function(_0x4c9a9d, _0x150e34) {
      return _0x4c9a9d(_0x150e34);
    }, "xKyzD": function(_0x21a011, _0xbec0cd) {
      return _0x21a011 < _0xbec0cd;
    }, "DBvmG": function(_0x426e46, _0x489a87) {
      return _0x426e46(_0x489a87);
    }, "xPojB": _0x42e3f8(409), "uDBpe": function(_0x1715e3, _0x3a0d38) {
      return _0x1715e3 > _0x3a0d38;
    } };
    this[_0x42e3f8(486)](), this[_0x42e3f8(406)]["recordEvents"](_0x3a7de7)[_0x42e3f8(440)]((_0x323e10) => {
      const _0xff2393 = _0x42e3f8;
      if (_0xc6e966[_0xff2393(420)](_0xc6e966[_0xff2393(447)](String, _0x323e10["status"]), _0xc6e966[_0xff2393(415)])) {
        this[_0xff2393(460)]();
        return;
      }
      if (_0xc6e966[_0xff2393(420)](_0xc6e966[_0xff2393(403)](String, _0x323e10[_0xff2393(463)])[0], "4")) return;
      if (_0xc6e966[_0xff2393(420)](String(_0x323e10[_0xff2393(463)])[0], "5")) {
        _0xc6e966[_0xff2393(499)](this[_0xff2393(417)], 5) && (this[_0xff2393(417)]++, this[_0xff2393(480)] = this[_0xff2393(480)] * 2.71, this[_0xff2393(460)]());
        return;
      }
      this[_0xff2393(417)] = 1, this[_0xff2393(480)] = 2e3;
      if (_0xc6e966[_0xff2393(420)](_0xc6e966[_0xff2393(441)](String, _0x323e10[_0xff2393(463)]), _0xc6e966[_0xff2393(473)])) {
        this[_0xff2393(457)]++, this[_0xff2393(406)]["taskSolution"] = void 0;
        if (_0xc6e966[_0xff2393(426)](this[_0xff2393(457)], 3)) {
          this["startBatching"]();
          return;
        } else {
          this["appModule"][_0xff2393(435)](), this[_0xff2393(460)]();
          return;
        }
      }
      this["taskRetry"] = 0, this[_0xff2393(419)][_0xff2393(491)](this[_0xff2393(419)][_0xff2393(471)]()["filter"]((_0x261793) => !_0x3a7de7[_0xff2393(433)]((_0x5bd2c8) => JSON[_0xff2393(408)](_0x261793) === JSON[_0xff2393(408)](_0x5bd2c8)))), this[_0xff2393(460)]();
    }, (_0x4ad0d6) => {
      const _0x1c60fd = _0x42e3f8;
      console["log"](_0x4ad0d6), this[_0x1c60fd(460)]();
    });
  }
}
function _0x4f48(_0x42bf3d, _0x919208) {
  var _0xe044dc = _0xe044();
  return _0x4f48 = function(_0x4f48ec, _0x12467e) {
    _0x4f48ec = _0x4f48ec - 225;
    var _0x454e1e = _0xe044dc[_0x4f48ec];
    return _0x454e1e;
  }, _0x4f48(_0x42bf3d, _0x919208);
}
function _0xe044() {
  var _0x2bc063 = ["oTJDr", "solveTask", "data", "pKriA", "4939039MsjByv", "772952cRHhFC", "9639KIeOBk", "setNewArgs", "c3e068ebf11840ed3fc311a6f2df80b20fa05d25", "then", "biYpd", "279248LdAlCP", "CZViX", "EbwrL", "zUFWU", "Ofrdm", "kNVOX", "4888lQqZvH", "worker", "appModule", "cBJhF", "postMessage", "UieMh", "taskSolution", "2WppaDh", "taskParams", "onmessage", "50yvDvSE", "createObjectURL", "40rLeQOs", "cQTRb", "blob", "3998298NkjdaL", "5392308hGRQSU", "1958011Hxtemr"];
  _0xe044 = function() {
    return _0x2bc063;
  };
  return _0xe044();
}
var _0x2763fc = _0x4f48;
(function(_0x59b002, _0x5885fe) {
  var _0x8a9b00 = _0x4f48, _0x5c76ef = _0x59b002();
  while (!![]) {
    try {
      var _0xf1e407 = -parseInt(_0x8a9b00(226)) / 1 * (-parseInt(_0x8a9b00(242)) / 2) + -parseInt(_0x8a9b00(234)) / 3 + -parseInt(_0x8a9b00(248)) / 4 * (parseInt(_0x8a9b00(231)) / 5) + parseInt(_0x8a9b00(235)) / 6 + parseInt(_0x8a9b00(241)) / 7 + -parseInt(_0x8a9b00(254)) / 8 * (parseInt(_0x8a9b00(243)) / 9) + -parseInt(_0x8a9b00(229)) / 10 * (-parseInt(_0x8a9b00(236)) / 11);
      if (_0xf1e407 === _0x5885fe) break;
      else _0x5c76ef["push"](_0x5c76ef["shift"]());
    } catch (_0x3cbc14) {
      _0x5c76ef["push"](_0x5c76ef["shift"]());
    }
  }
})(_0xe044, 721609);
class HumanProofService {
  constructor(_0x5e5cc0) {
    this["appModule"] = _0x5e5cc0;
  }
  async ["init"]() {
    var _0x4a94f0 = _0x4f48, _0x34b915 = { "meFfk": function(_0x5375ae, _0x45f127) {
      return _0x5375ae === _0x45f127;
    }, "cQTRb": function(_0x30ca96, _0x475c1c) {
      return _0x30ca96(_0x475c1c);
    }, "pKriA": function(_0x580662) {
      return _0x580662();
    }, "mWehp": function(_0x40112f, _0xeb1a7d) {
      return _0x40112f !== _0xeb1a7d;
    }, "UieMh": function(_0x226c06, _0x4fc314) {
      return _0x226c06(_0x4fc314);
    }, "UHaKE": "aee7c93a9ae7930fb19732325d2c560c53849aa7", "zUFWU": function(_0x5973c4, _0x4330e9) {
      return _0x5973c4 === _0x4330e9;
    }, "kNVOX": "EinkV", "CZViX": "oeaiB", "lbsog": function(_0x305ed7, _0x4e4259) {
      return _0x305ed7 + _0x4e4259;
    }, "qClXH": _0x4a94f0(245) };
    return new Promise(async (_0x585228, _0x2811ac) => {
      var _0x3d6709 = _0x4a94f0;
      if (_0x34b915[_0x3d6709(251)](_0x34b915[_0x3d6709(253)], _0x34b915[_0x3d6709(249)])) this[_0x3d6709(256)] = _0x320551;
      else try {
        await _0x34b915[_0x3d6709(232)](fetch, _0x34b915["lbsog"](BACKEND_URL, _0x34b915["qClXH"]))[_0x3d6709(246)](async (_0xe93fa8) => {
          var _0x4bda06 = _0x3d6709, _0x380e09 = { "oTJDr": function(_0x10afb2, _0x18af80) {
            return _0x34b915["meFfk"](_0x10afb2, _0x18af80);
          }, "cBJhF": function(_0x354705, _0x31f675) {
            var _0x5ce42e = _0x4f48;
            return _0x34b915[_0x5ce42e(232)](_0x354705, _0x31f675);
          }, "Ofrdm": function(_0x1a55ec) {
            var _0x39e1a2 = _0x4f48;
            return _0x34b915[_0x39e1a2(240)](_0x1a55ec);
          } };
          _0x34b915["mWehp"](_0x4bda06(250), "IJxHv") ? (this["worker"] = new Worker(URL[_0x4bda06(230)](await _0xe93fa8[_0x4bda06(233)]())), await _0x34b915[_0x4bda06(259)](fetch, BACKEND_URL + _0x34b915["UHaKE"])[_0x4bda06(246)](async (_0x314143) => {
            var _0x484517 = _0x4bda06;
            this[_0x484517(256)][_0x484517(227)] = _0x380e09[_0x484517(257)](String, await _0x314143["text"]()), this["worker"][_0x484517(228)] = (_0x3ded93) => {
              var _0x369cfd = _0x484517;
              _0x380e09[_0x369cfd(237)](_0x369cfd(247), _0x369cfd(247)) ? this["appModule"][_0x369cfd(225)] = _0x3ded93[_0x369cfd(239)] : (this[_0x369cfd(256)][_0x369cfd(227)] = _0x4efc99, this[_0x369cfd(238)]());
            }, _0x380e09[_0x484517(252)](_0x585228);
          })) : this[_0x4bda06(255)][_0x4bda06(258)](this["appModule"][_0x4bda06(227)]);
        });
      } catch (_0x4504a1) {
        _0x34b915["cQTRb"](_0x2811ac, _0x4504a1);
      }
    });
  }
  [_0x2763fc(244)](_0x4dcc4b) {
    var _0xa3b9c6 = _0x2763fc;
    this[_0xa3b9c6(256)][_0xa3b9c6(227)] = _0x4dcc4b, this[_0xa3b9c6(238)]();
  }
  [_0x2763fc(238)]() {
    var _0x1971e8 = _0x2763fc;
    this["worker"] !== void 0 && this[_0x1971e8(255)]["postMessage"](this[_0x1971e8(256)][_0x1971e8(227)]);
  }
}
function _0x3c94() {
  var _0x1d3ee9 = ["tcomc", "getApiToken", "INVOICE_REGISTERED", "collect", "appName", "init", "assembleEventSession", "0|1|3|5|7|6|2|4", "6244217Tmxkpd", "recordEvents", "4185452nQgZVe", "3238032APKtDJ", "collectTappsEvent", "solveTask", "3921927dupOvD", "2jPWlZY", "1|0|3|4|2", "humanProofService", "1988487XYqpHt", "30KGiTwB", "1069032efdjbx", "registerInvoice", "getAppName", "getUserData", "setNewArgs", "networkController", "analyticsController", "1616980DyzPcj", "collectEvent", "apiToken", "batchService", "env", "12Taeksc", "catch", "split", "sessionController"];
  _0x3c94 = function() {
    return _0x1d3ee9;
  };
  return _0x3c94();
}
var _0x240f70 = _0x51ad;
(function(_0x3dafac, _0x22e8d0) {
  var _0x299089 = _0x51ad, _0x47e86b = _0x3dafac();
  while (!![]) {
    try {
      var _0x109d52 = parseInt(_0x299089(367)) / 1 + -parseInt(_0x299089(362)) / 2 * (parseInt(_0x299089(361)) / 3) + parseInt(_0x299089(357)) / 4 + parseInt(_0x299089(374)) / 5 * (parseInt(_0x299089(343)) / 6) + -parseInt(_0x299089(355)) / 7 + -parseInt(_0x299089(358)) / 8 + parseInt(_0x299089(365)) / 9 * (parseInt(_0x299089(366)) / 10);
      if (_0x109d52 === _0x22e8d0) break;
      else _0x47e86b["push"](_0x47e86b["shift"]());
    } catch (_0x8d19ae) {
      _0x47e86b["push"](_0x47e86b["shift"]());
    }
  }
})(_0x3c94, 820922);
function _0x51ad(_0x1f822a, _0x34731c) {
  var _0x3c94c2 = _0x3c94();
  return _0x51ad = function(_0x51adbb, _0x2d6e3f) {
    _0x51adbb = _0x51adbb - 341;
    var _0x3ff1d1 = _0x3c94c2[_0x51adbb];
    return _0x3ff1d1;
  }, _0x51ad(_0x1f822a, _0x34731c);
}
class App {
  constructor(_0x5aee85, _0x40229b, _0x416ba5) {
    var _0x4b4300 = _0x51ad, _0x368df4 = _0x4b4300(354)[_0x4b4300(345)]("|"), _0x289d22 = 0;
    while (!![]) {
      switch (_0x368df4[_0x289d22++]) {
        case "0":
          this[_0x4b4300(342)] = _0x416ba5;
          continue;
        case "1":
          this[_0x4b4300(376)] = _0x5aee85;
          continue;
        case "2":
          this[_0x4b4300(373)] = new AnalyticsController(this);
          continue;
        case "3":
          this["appName"] = _0x40229b;
          continue;
        case "4":
          this[_0x4b4300(341)] = new BatchService(this);
          continue;
        case "5":
          this[_0x4b4300(364)] = new HumanProofService(this);
          continue;
        case "6":
          this[_0x4b4300(372)] = new NetworkController(this);
          continue;
        case "7":
          this[_0x4b4300(346)] = new SessionController(this);
          continue;
      }
      break;
    }
  }
  async [_0x240f70(352)]() {
    var _0x3cd3d0 = _0x240f70, _0x531575 = { "tcomc": _0x3cd3d0(363) }, _0x582da4 = _0x531575[_0x3cd3d0(347)][_0x3cd3d0(345)]("|"), _0x14688c = 0;
    while (!![]) {
      switch (_0x582da4[_0x14688c++]) {
        case "0":
          await this["analyticsController"][_0x3cd3d0(352)]();
          continue;
        case "1":
          this[_0x3cd3d0(346)][_0x3cd3d0(352)]();
          continue;
        case "2":
          this[_0x3cd3d0(341)]["init"]();
          continue;
        case "3":
          await this["humanProofService"][_0x3cd3d0(352)]()["then"](() => {
            var _0x18481e = _0x3cd3d0;
            this[_0x18481e(360)]();
          })[_0x3cd3d0(344)]((_0x438ab2) => console["error"](_0x438ab2));
          continue;
        case "4":
          this["networkController"]["init"]();
          continue;
      }
      break;
    }
  }
  ["assembleEventSession"]() {
    var _0x3471ac = _0x240f70;
    return this[_0x3471ac(346)][_0x3471ac(353)]();
  }
  ["recordEvent"](_0x253f7c, _0x1d0794, _0x233c8a) {
    var _0x7068b6 = _0x240f70;
    return this[_0x7068b6(372)]["recordEvent"](_0x253f7c, _0x1d0794, _0x233c8a);
  }
  ["recordEvents"](_0x26d801) {
    var _0x1ce8c9 = _0x240f70;
    return this[_0x1ce8c9(372)][_0x1ce8c9(356)](_0x26d801);
  }
  [_0x240f70(375)](_0x4e2477, _0x3f000a) {
    var _0x3c9a94 = _0x240f70;
    this["batchService"][_0x3c9a94(350)](_0x4e2477, { ..._0x3f000a, ...this[_0x3c9a94(353)]() });
  }
  [_0x240f70(368)](_0x318673) {
    var _0xa0d247 = _0x240f70;
    this[_0xa0d247(341)][_0xa0d247(350)](Events[_0xa0d247(349)], { ..._0x318673, ...this["assembleEventSession"]() });
  }
  [_0x240f70(359)](_0x5d3914, _0x4f0c94) {
    var _0x5459bc = _0x240f70;
    this[_0x5459bc(341)]["collect"](_0x5d3914, { ...this[_0x5459bc(346)][_0x5459bc(353)](), "custom_data": { "userData": { ...this[_0x5459bc(346)][_0x5459bc(370)]() }, ..._0x4f0c94 } });
  }
  [_0x240f70(348)]() {
    var _0x340595 = _0x240f70;
    return this[_0x340595(376)];
  }
  [_0x240f70(369)]() {
    var _0x12646f = _0x240f70;
    return this[_0x12646f(351)];
  }
  ["solveTask"]() {
    var _0x44c293 = _0x240f70;
    this[_0x44c293(364)][_0x44c293(360)]();
  }
  [_0x240f70(371)](_0x50914a) {
    var _0x145e76 = _0x240f70;
    this[_0x145e76(364)]["setNewArgs"](_0x50914a);
  }
}
function _0x2d47() {
  const _0x4f1eee = ["length", "suggested_tip_amounts", "kzTQt", "446539oZuPAZ", 'Each price must have a positive "amount" number', "currency", "ALMCe", "Ybfqb", "RKeyG", 'All values in "suggested_tip_amounts" must be numbers', "amount", "gibKx", "bwUvl", "need_email", "YBtzd", "isArray", 'Field "prices" must be a non-empty array', "is_flexible", "mPzrq", "IGhKL", "cwReF", "GolEh", 'Each price must have a "label" string', "1740321vBYeIZ", "photo_size", '" is required and must be a string', "need_phone_number", "send_phone_number_to_provider", "OsxHh", "GAPZd", "Wpeko", "lMslG", "MKawy", "zwBUY", "57099trPHOq", "boolean", "272096esZtBO", "subscription_period", "UOsVR", "DKQvj", "gLBNL", "prices", "UnIsT", "ZyTVV", "Xosed", "thIzd", "cBLOr", "VrZPh", "number", "16teHGaE", "max_tip_amount", "label", "need_name", "Payload is required", "slug", "string", "844228zhHRUg", "113034FebSJN", "VSmQn", '" must be a number if provided', "description", "yCMfL", 'Field "suggested_tip_amounts" must be an array if provided', '" must be a boolean if provided', "sQITi", "send_email_to_provider", "lXuxo", "EhDHF", "Aqico", "20QkdSZJ", "HHHCU", "urXSs", "GKBSg", 'Field "', "dJaaN", "FcTNf", "GKdhq", "need_shipping_address", "ABxqv", "photo_height", "725301KithZq", "MlhPQ", "DszRh", "tNZYy"];
  _0x2d47 = function() {
    return _0x4f1eee;
  };
  return _0x2d47();
}
(function(_0x4bfd04, _0x2bec11) {
  const _0x47042f = _0x4201, _0x1b9d2b = _0x4bfd04();
  while (!![]) {
    try {
      const _0x240b45 = -parseInt(_0x47042f(298)) / 1 + -parseInt(_0x47042f(331)) / 2 + parseInt(_0x47042f(318)) / 3 + parseInt(_0x47042f(267)) / 4 + -parseInt(_0x47042f(280)) / 5 * (-parseInt(_0x47042f(268)) / 6) + parseInt(_0x47042f(329)) / 7 * (-parseInt(_0x47042f(260)) / 8) + parseInt(_0x47042f(291)) / 9;
      if (_0x240b45 === _0x2bec11) break;
      else _0x1b9d2b["push"](_0x1b9d2b["shift"]());
    } catch (_0x54d921) {
      _0x1b9d2b["push"](_0x1b9d2b["shift"]());
    }
  }
})(_0x2d47, 348208);
function _0x4201(_0x5094c2, _0x2cdf7f) {
  const _0x2d472b = _0x2d47();
  return _0x4201 = function(_0x4201c4, _0xb86330) {
    _0x4201c4 = _0x4201c4 - 250;
    let _0x1d5338 = _0x2d472b[_0x4201c4];
    return _0x1d5338;
  }, _0x4201(_0x5094c2, _0x2cdf7f);
}
function validateInvoicePayload(_0x5490ac) {
  const _0x3eb132 = _0x4201, _0x4121f8 = { "cwReF": _0x3eb132(264), "yCMfL": function(_0x3f72f8, _0x3fa66b) {
    return _0x3f72f8 in _0x3fa66b;
  }, "YBtzd": _0x3eb132(330), "GAPZd": _0x3eb132(259), "BkZHm": _0x3eb132(304), "apQIt": _0x3eb132(311), "dJaaN": function(_0x37b3f8, _0x336a6b) {
    return _0x37b3f8 === _0x336a6b;
  }, "GolEh": _0x3eb132(293), "sQITi": _0x3eb132(265), "Xosed": "title", "Wpeko": _0x3eb132(271), "RKeyG": "payload", "UOsVR": function(_0x3d97be, _0x265ec5) {
    return _0x3d97be === _0x265ec5;
  }, "UnIsT": _0x3eb132(269), "cBLOr": function(_0x54c6fe, _0x13aa7e) {
    return _0x54c6fe !== _0x13aa7e;
  }, "zwBUY": _0x3eb132(266), "MKawy": function(_0x5539f5, _0x2e8eb2) {
    return _0x5539f5 === _0x2e8eb2;
  }, "HHHCU": _0x3eb132(297), "LRcsf": _0x3eb132(254), "VrZPh": function(_0x12e160, _0x197444) {
    return _0x12e160 === _0x197444;
  }, "tNZYy": _0x3eb132(279), "EhDHF": function(_0x38b67f, _0x35de8f) {
    return _0x38b67f !== _0x35de8f;
  }, "GKBSg": _0x3eb132(299), "lXuxo": _0x3eb132(332), "urXSs": _0x3eb132(319), "gibKx": "photo_width", "OsxHh": function(_0x22c4f0, _0x47325a) {
    return _0x22c4f0 !== _0x47325a;
  }, "thIzd": function(_0x1b75f4, _0x4fb311) {
    return _0x1b75f4 in _0x4fb311;
  }, "shnln": "suggested_tip_amounts", "ABxqv": _0x3eb132(286), "Ybfqb": _0x3eb132(273), "MlhPQ": _0x3eb132(250), "gLBNL": "NtvBn", "mGzGK": _0x3eb132(263), "lMslG": _0x3eb132(321), "IGhKL": _0x3eb132(308), "hSppR": _0x3eb132(288), "GKdhq": _0x3eb132(322), "mPzrq": _0x3eb132(276), "wLfgf": _0x3eb132(312), "ALMCe": function(_0x41eb48, _0x546dc3) {
    return _0x41eb48 !== _0x546dc3;
  } };
  if (!_0x5490ac) {
    if (_0x4121f8[_0x3eb132(285)](_0x4121f8[_0x3eb132(316)], _0x4121f8[_0x3eb132(316)])) throw new Error(_0x4121f8[_0x3eb132(315)]);
    else {
      if (_0x12ef19 in _0x1d44a3 && typeof _0x44e6c2[_0x28ed1e] !== _0x3eb132(259)) throw new _0x2c01f1(_0x3eb132(284) + _0x54955f + _0x3eb132(270));
    }
  }
  const _0x9baf26 = [_0x4121f8[_0x3eb132(275)], _0x4121f8[_0x3eb132(255)], _0x4121f8[_0x3eb132(325)], _0x4121f8[_0x3eb132(303)], _0x3eb132(300)];
  for (const _0x227c63 of _0x9baf26) {
    if (_0x4121f8[_0x3eb132(333)](_0x4121f8[_0x3eb132(253)], _0x4121f8[_0x3eb132(253)])) {
      if (!_0x5490ac[_0x227c63] || _0x4121f8["cBLOr"](typeof _0x5490ac[_0x227c63], _0x4121f8["zwBUY"])) {
        if (_0x4121f8[_0x3eb132(327)](_0x4121f8[_0x3eb132(281)], _0x4121f8["LRcsf"])) throw new _0x264ee0(_0x4121f8[_0x3eb132(315)]);
        else throw new Error(_0x3eb132(284) + _0x227c63 + _0x3eb132(320));
      }
    } else {
      if (_0x4121f8[_0x3eb132(272)](_0x5ac26e, _0x237f5b) && typeof _0x504f44[_0x2667b9] !== _0x4121f8[_0x3eb132(309)]) throw new _0x3264ec('Field "' + _0x3e12c2 + _0x3eb132(274));
    }
  }
  if (!Array[_0x3eb132(310)](_0x5490ac[_0x3eb132(252)]) || _0x4121f8[_0x3eb132(258)](_0x5490ac[_0x3eb132(252)][_0x3eb132(295)], 0)) throw new Error(_0x3eb132(311));
  for (const _0x59c8d1 of _0x5490ac[_0x3eb132(252)]) {
    if (_0x4121f8[_0x3eb132(257)](_0x4121f8[_0x3eb132(294)], _0x4121f8["tNZYy"])) throw new _0xd978e7('Field "' + _0x1fe68e + _0x3eb132(270));
    else {
      if (!_0x59c8d1[_0x3eb132(262)] || _0x4121f8[_0x3eb132(257)](typeof _0x59c8d1["label"], _0x4121f8[_0x3eb132(328)])) throw new Error(_0x3eb132(317));
      if (_0x4121f8[_0x3eb132(278)](typeof _0x59c8d1[_0x3eb132(305)], _0x4121f8[_0x3eb132(324)]) || _0x59c8d1[_0x3eb132(305)] <= 0) throw new Error(_0x4121f8[_0x3eb132(283)]);
    }
  }
  const _0x2d3073 = [_0x4121f8[_0x3eb132(277)], _0x3eb132(261), _0x4121f8[_0x3eb132(282)], _0x4121f8[_0x3eb132(306)], _0x3eb132(290)];
  for (const _0x2a32e0 of _0x2d3073) {
    if (_0x4121f8[_0x3eb132(272)](_0x2a32e0, _0x5490ac) && _0x4121f8[_0x3eb132(323)](typeof _0x5490ac[_0x2a32e0], _0x4121f8[_0x3eb132(324)])) throw new Error('Field "' + _0x2a32e0 + _0x3eb132(270));
  }
  if (_0x4121f8[_0x3eb132(256)](_0x4121f8["shnln"], _0x5490ac)) {
    if (_0x4121f8["MKawy"](_0x4121f8[_0x3eb132(289)], _0x3eb132(307))) {
      if (!_0x2f7406[_0x3eb132(310)](_0x414ae7[_0x3eb132(296)])) throw new _0x20b62b(_0x3eb132(273));
      for (const _0x418197 of _0x1114cf["suggested_tip_amounts"]) {
        if (typeof _0x418197 !== _0x4121f8["GAPZd"]) throw new _0x45094e(_0x4121f8["BkZHm"]);
      }
    } else {
      if (!Array[_0x3eb132(310)](_0x5490ac["suggested_tip_amounts"])) throw new Error(_0x4121f8[_0x3eb132(302)]);
      for (const _0x1ff93c of _0x5490ac[_0x3eb132(296)]) {
        if (_0x4121f8["OsxHh"](_0x4121f8[_0x3eb132(292)], _0x4121f8[_0x3eb132(251)])) {
          if (typeof _0x1ff93c !== _0x4121f8[_0x3eb132(324)]) throw new Error(_0x4121f8["BkZHm"]);
        } else throw new _0x4037ce(_0x4121f8["apQIt"]);
      }
    }
  }
  const _0xc6aaf6 = [_0x4121f8["mGzGK"], _0x4121f8[_0x3eb132(326)], _0x4121f8[_0x3eb132(314)], _0x4121f8["hSppR"], _0x4121f8[_0x3eb132(287)], _0x4121f8[_0x3eb132(313)], _0x4121f8["wLfgf"]];
  for (const _0x16e2f5 of _0xc6aaf6) {
    if (_0x4121f8[_0x3eb132(272)](_0x16e2f5, _0x5490ac) && _0x4121f8[_0x3eb132(301)](typeof _0x5490ac[_0x16e2f5], _0x4121f8[_0x3eb132(309)])) throw new Error('Field "' + _0x16e2f5 + '" must be a boolean if provided');
  }
}
const _0x3e3c81 = _0x3b6e;
(function(_0x1bc9d9, _0x45eb78) {
  const _0x2af054 = _0x3b6e, _0x54b705 = _0x1bc9d9();
  while (!![]) {
    try {
      const _0x31ccf5 = -parseInt(_0x2af054(307)) / 1 * (-parseInt(_0x2af054(299)) / 2) + parseInt(_0x2af054(302)) / 3 + -parseInt(_0x2af054(297)) / 4 * (-parseInt(_0x2af054(306)) / 5) + -parseInt(_0x2af054(296)) / 6 + parseInt(_0x2af054(305)) / 7 * (parseInt(_0x2af054(300)) / 8) + parseInt(_0x2af054(309)) / 9 * (-parseInt(_0x2af054(304)) / 10) + parseInt(_0x2af054(298)) / 11 * (parseInt(_0x2af054(308)) / 12);
      if (_0x31ccf5 === _0x45eb78) break;
      else _0x54b705["push"](_0x54b705["shift"]());
    } catch (_0x338069) {
      _0x54b705["push"](_0x54b705["shift"]());
    }
  }
})(_0x3c7a, 852286);
let __registerInvoice;
async function init({ token: _0x5e55f7, appName: _0x319974, env = _0x3e3c81(310) }) {
  const _0x57a80c = _0x3e3c81, _0x5bf960 = { "VHVLp": function(_0x287bb9, _0x34fd95) {
    return _0x287bb9(_0x34fd95);
  } }, _0x36c9b2 = new App(_0x5e55f7, _0x319974, env);
  __registerInvoice = (_0x479246) => {
    const _0x49c03e = _0x3b6e;
    _0x5bf960[_0x49c03e(303)](validateInvoicePayload, _0x479246), _0x36c9b2[_0x49c03e(301)](_0x479246);
  }, await _0x36c9b2[_0x57a80c(311)]();
}
function _0x3b6e(_0x310a5a, _0xa1c8a5) {
  const _0x3c7a4d = _0x3c7a();
  return _0x3b6e = function(_0x3b6ede, _0x482088) {
    _0x3b6ede = _0x3b6ede - 296;
    let _0x4d08a4 = _0x3c7a4d[_0x3b6ede];
    return _0x4d08a4;
  }, _0x3b6e(_0x310a5a, _0xa1c8a5);
}
function _0x3c7a() {
  const _0x100d36 = ["397602pOYUSW", "VHVLp", "13963670vTlDmw", "7870191NshtRZ", "15HmCwhi", "1LzeYxx", "1625688NafrTT", "9zoDkIJ", "PROD", "init", "1861266GGQhBs", "722260gxeqQf", "22BAsDRU", "978748WjBqut", "8XzPmvw", "registerInvoice"];
  _0x3c7a = function() {
    return _0x100d36;
  };
  return _0x3c7a();
}
const index = { "init": init, "registerInvoice": (_0x30e734) => __registerInvoice(_0x30e734) };
export {
  index as default
};
